type LogoAsset = {
      asset?: NodeRequire;
      aspectRatio: number;
    };
    type imageAssetMap = { [index: string]: LogoAsset };
export const imageAssets: imageAssetMap = { 
"1up-demo-health-plan": { aspectRatio: 4.57 },
"1up": { aspectRatio: 1.00 },
"aaci": { aspectRatio: 1.00 },
"absolute-total-care": { aspectRatio: 1.51 },
"absolute-totalcare": { aspectRatio: 1.51 },
"access-community-health-centers": { aspectRatio: 3.46 },
"access-community-health-network": { aspectRatio: 2.33 },
"acentra-health": { aspectRatio: 1.24 },
"act-health": { aspectRatio: 1.41 },
"acumen-physician-solutions": { aspectRatio: 1.33 },
"adams-memorial-hospital": { aspectRatio: 1.00 },
"adams-school-of-dentistry-for-unc": { aspectRatio: 4.00 },
"adapt-integrated-health-care": { aspectRatio: 2.84 },
"adaptive-biotech": { aspectRatio: 3.88 },
"adena-health-system": { aspectRatio: 1.00 },
"advance-community-health": { aspectRatio: 3.66 },
"advanced-radiology": { aspectRatio: 1.00 },
"advanced-spine-and-pain-specialists": { aspectRatio: 2.91 },
"advanced-vascular-surgery": { aspectRatio: 2.13 },
"advantagecare-physicians": { aspectRatio: 2.21 },
"adventhealth": { aspectRatio: 3.66 },
"adventist-health-columbia-gorge": { aspectRatio: 1.78 },
"adventist-health": { aspectRatio: 3.66 },
"advocate-aurora-health": { aspectRatio: 1.78 },
"aetna-rtpbc": { aspectRatio: 1.41 },
"aetna": { aspectRatio: 1.73 },
"agape-health-services": { aspectRatio: 1.00 },
"aids-healthcare-foundation-ahf": { aspectRatio: 0.90 },
"aids-healthcare-foundation": { aspectRatio: 0.90 },
"aihs-guide": { aspectRatio: 3.05 },
"akron-children-s": { aspectRatio: 2.29 },
"alabama-state-medicaid": { aspectRatio: 9.85 },
"alameda-health-system": { aspectRatio: 5.57 },
"alaska-department-of-health": { aspectRatio: 1.00 },
"alaska-neurology-center": { aspectRatio: 4.57 },
"alaska-regional-hospital": { aspectRatio: 1.00 },
"alaska-state-medicaid": { aspectRatio: 1.00 },
"albany-county-department-of-health": { aspectRatio: 1.22 },
"albany-med-health-system": { aspectRatio: 1.78 },
"alberta-health-services": { aspectRatio: 3.37 },
"align-senior-care": { aspectRatio: 2.00 },
"aligned-geriatrics": { aspectRatio: 1.00 },
"alignment-corporation": { aspectRatio: 6.10 },
"alignment-health-plan": { aspectRatio: 6.10 },
"alignment-health": { aspectRatio: 2.00 },
"all-care-health-center": { aspectRatio: 3.76 },
"allcare-advantage": { aspectRatio: 2.46 },
"allcare-cco": { aspectRatio: 2.46 },
"allcare-health": { aspectRatio: 2.51 },
"alleghany-health": { aspectRatio: 1.05 },
"allegheny-health-network": { aspectRatio: 3.20 },
"alliance-health-centers": { aspectRatio: 1.00 },
"alliance-health": { aspectRatio: 1.00 },
"alliance-medical-center": { aspectRatio: 2.42 },
"alliant-health-plans": { aspectRatio: 1.24 },
"allied-benefit": { aspectRatio: 1.00 },
"allied-national": { aspectRatio: 2.61 },
"allina": { aspectRatio: 1.91 },
"aloha-care": { aspectRatio: 1.00 },
"altais-health-solutions": { aspectRatio: 1.15 },
"altamed": { aspectRatio: 2.61 },
"alterwood-advantage": { aspectRatio: 4.27 },
"altru": { aspectRatio: 3.76 },
"always-assist": { aspectRatio: 2.56 },
"ambetter": { aspectRatio: 1.00 },
"american-health-advantage-of-mississippi": { aspectRatio: 3.56 },
"american-health-advantage-of-tennessee": { aspectRatio: 3.56 },
"american-health-advantage-of-texas": { aspectRatio: 3.46 },
"american-health-plans": { aspectRatio: 4.27 },
"american-university-of-beirut-medical-center": { aspectRatio: 2.37 },
"amerihealth-caritas-delaware": { aspectRatio: 1.00 },
"amerihealth-caritas-district-of-columbia": { aspectRatio: 1.00 },
"amerihealth-caritas-family-of-companies": { aspectRatio: 1.52 },
"amerihealth-caritas-florida": { aspectRatio: 1.91 },
"amerihealth-caritas-louisiana": { aspectRatio: 2.46 },
"amerihealth-caritas-ncex": { aspectRatio: 1.00 },
"amerihealth-caritas-new-hampshire": { aspectRatio: 1.00 },
"amerihealth-caritas-next-delaware": { aspectRatio: 2.13 },
"amerihealth-caritas-next-florida": { aspectRatio: 2.13 },
"amerihealth-caritas-north-carolina": { aspectRatio: 1.00 },
"amerihealth-caritas-ohio": { aspectRatio: 1.00 },
"amerihealth-caritas-pennsylvania-community-healthchoices": { aspectRatio: 5.82 },
"amerihealth-caritas-pennsylvania": { aspectRatio: 1.52 },
"amerihealth-caritas-performcare-pennsylvania": { aspectRatio: 1.00 },
"amerihealth-caritas-vip-care-florida": { aspectRatio: 2.78 },
"amerihealth-caritas-vip-care-plus": { aspectRatio: 2.78 },
"amerihealth-caritas-vip-care": { aspectRatio: 2.78 },
"amida-care": { aspectRatio: 3.05 },
"amphia": { aspectRatio: 3.12 },
"amsterdam-umc": { aspectRatio: 6.10 },
"anchorage-neighborhood-health-center": { aspectRatio: 1.00 },
"anchorage-neurosurgical-associates": { aspectRatio: 1.00 },
"anmed-health": { aspectRatio: 2.21 },
"ann-and-robert-h-lurie-children-s-hospital-of-chicago": { aspectRatio: 4.00 },
"anthem-amerigroup-medicaid": { aspectRatio: 3.28 },
"anthem-amerigroup": { aspectRatio: 1.68 },
"anthem-blue-cross-blue-shield": { aspectRatio: 6.40 },
"anthem-blue-cross-ca": { aspectRatio: 1.78 },
"anthem-blue-cross": { aspectRatio: 3.46 },
"anthem-medicaid": { aspectRatio: 1.00 },
"anthem": { aspectRatio: 1.78 },
"antidote-health-plan": { aspectRatio: 1.91 },
"apotti": { aspectRatio: 2.33 },
"appleton-health": { aspectRatio: 1.00 },
"arizona-community-physicians": { aspectRatio: 2.21 },
"arizona-complete-health": { aspectRatio: 2.00 },
"arkansas-blue-cross-and-blue-shield": { aspectRatio: 1.91 },
"arkansas-children-s": { aspectRatio: 2.06 },
"arkansas-medicaid": { aspectRatio: 3.28 },
"arkansas-state-medicaid": { aspectRatio: 1.00 },
"arkansas-total-care": { aspectRatio: 1.51 },
"arlington-maternal-fetal-specialists": { aspectRatio: 1.00 },
"arrowhead-orthopaedics": { aspectRatio: 2.72 },
"arrowhead-regional-medical-center": { aspectRatio: 2.46 },
"articularis": { aspectRatio: 1.44 },
"asante-health-system": { aspectRatio: 5.57 },
"ascension-complete": { aspectRatio: 4.00 },
"ascension-illinois": { aspectRatio: 4.00 },
"ascension-providence-healthcare-network": { aspectRatio: 1.00 },
"ascension-wisconsin": { aspectRatio: 3.20 },
"ashland-medical-center": { aspectRatio: 1.00 },
"asian-counseling-and-referral-service": { aspectRatio: 1.00 },
"asian-health-services": { aspectRatio: 1.78 },
"aspen-valley-health": { aspectRatio: 2.21 },
"aspire-health-plan": { aspectRatio: 3.05 },
"aspire": { aspectRatio: 2.17 },
"aspirus-health-plan": { aspectRatio: 1.44 },
"aspirus": { aspectRatio: 3.20 },
"asr-health-benefits": { aspectRatio: 2.46 },
"astera-health": { aspectRatio: 5.33 },
"asuris-northwest-health": { aspectRatio: 1.00 },
"asuris": { aspectRatio: 1.00 },
"athena-health": { aspectRatio: 1.49 },
"athenahealth": { aspectRatio: 1.49 },
"atlantic-health-system": { aspectRatio: 2.84 },
"atrio-health-plans": { aspectRatio: 1.00 },
"atrium-health": { aspectRatio: 1.88 },
"atrius-health": { aspectRatio: 1.91 },
"audubon-county-memorial-hospital-and-clinics": { aspectRatio: 2.91 },
"aultcare-insurance-company": { aspectRatio: 7.11 },
"aultcare": { aspectRatio: 1.78 },
"austin-regional-clinic": { aspectRatio: 1.45 },
"automated-benefit-services": { aspectRatio: 2.10 },
"avenue-360": { aspectRatio: 1.00 },
"avera-health-plans": { aspectRatio: 1.00 },
"avesis-commercial": { aspectRatio: 2.78 },
"avesis-non-commercial": { aspectRatio: 2.78 },
"avesis": { aspectRatio: 2.00 },
"avita-health-system": { aspectRatio: 1.91 },
"avmed": { aspectRatio: 1.01 },
"axis-community-health": { aspectRatio: 8.00 },
"bailey-medical-center": { aspectRatio: 3.28 },
"balance-by-chinese-community-health-plan-cchp": { aspectRatio: 2.91 },
"ballad-health": { aspectRatio: 1.91 },
"baltimore-city-health-department": { aspectRatio: 2.13 },
"banner-health-system": { aspectRatio: 2.25 },
"banner-university-health-plans": { aspectRatio: 2.42 },
"baptist-health-northeast-florida": { aspectRatio: 2.21 },
"baptist-health": { aspectRatio: 3.76 },
"baptist-healthcare": { aspectRatio: 3.76 },
"baptist-memorial-health-care": { aspectRatio: 1.51 },
"barrett-hospital-and-healthcare": { aspectRatio: 1.78 },
"barton-health": { aspectRatio: 1.00 },
"bartz-altadonna-community-health-center": { aspectRatio: 1.56 },
"bassett-healthcare": { aspectRatio: 1.00 },
"baton-rouge-general": { aspectRatio: 2.91 },
"baton-rouge-orthopaedic-clinic": { aspectRatio: 2.21 },
"bay-area-community-health": { aspectRatio: 1.00 },
"bay-area-hospital": { aspectRatio: 3.37 },
"bay-clinic": { aspectRatio: 0.99 },
"baycare-clinic": { aspectRatio: 3.66 },
"baycare-health-plans": { aspectRatio: 2.91 },
"bayhealth-medical-center": { aspectRatio: 2.98 },
"baylor-scott-and-white-health": { aspectRatio: 1.62 },
"baylor": { aspectRatio: 1.91 },
"baywell-health": { aspectRatio: 1.66 },
"beam-benefits": { aspectRatio: 1.68 },
"bear-lake-memorial-clinic": { aspectRatio: 3.88 },
"beaumont": { aspectRatio: 1.00 },
"bee-busy-wellness-center": { aspectRatio: 1.04 },
"bellaire-allergy-and-asthma": { aspectRatio: 1.00 },
"bellin": { aspectRatio: 6.40 },
"ben-archer-health-center": { aspectRatio: 5.57 },
"benefis-health-system": { aspectRatio: 1.94 },
"bertie-county-rural-health": { aspectRatio: 1.00 },
"bestcare-treatment": { aspectRatio: 1.00 },
"beth-israel-lahey-health": { aspectRatio: 2.67 },
"bethlehem-health-bureau": { aspectRatio: 2.72 },
"billings-obgyn": { aspectRatio: 2.13 },
"biospine-institute": { aspectRatio: 1.00 },
"birmingham-women-s-and-children-s": { aspectRatio: 2.33 },
"bjc-healthcare-and-washington-university": { aspectRatio: 4.57 },
"blank": { aspectRatio: 1.00 },
"blue-choice-of-south-carolina": { aspectRatio: 3.66 },
"blue-cross-and-blue-shield-of-rhode-island": { aspectRatio: 1.60 },
"blue-cross-and-blue-shield-of-vermont": { aspectRatio: 1.00 },
"blue-cross-blue-shield-federal-employee-program": { aspectRatio: 4.41 },
"blue-cross-blue-shield-of-alabama": { aspectRatio: 3.76 },
"blue-cross-blue-shield-of-arizona": { aspectRatio: 4.00 },
"blue-cross-blue-shield-of-arkansas": { aspectRatio: 1.00 },
"blue-cross-blue-shield-of-illinois": { aspectRatio: 1.00 },
"blue-cross-blue-shield-of-kansas-city": { aspectRatio: 1.54 },
"blue-cross-blue-shield-of-kansas-medicare": { aspectRatio: 4.00 },
"blue-cross-blue-shield-of-kansas": { aspectRatio: 1.54 },
"blue-cross-blue-shield-of-louisiana-blueadvantage": { aspectRatio: 3.46 },
"blue-cross-blue-shield-of-louisiana": { aspectRatio: 1.78 },
"blue-cross-blue-shield-of-massachusetts": { aspectRatio: 1.91 },
"blue-cross-blue-shield-of-michigan": { aspectRatio: 1.00 },
"blue-cross-blue-shield-of-minnesota": { aspectRatio: 2.98 },
"blue-cross-blue-shield-of-mississippi": { aspectRatio: 5.82 },
"blue-cross-blue-shield-of-montana": { aspectRatio: 1.00 },
"blue-cross-blue-shield-of-nebraska": { aspectRatio: 2.98 },
"blue-cross-blue-shield-of-new-mexico": { aspectRatio: 2.00 },
"blue-cross-blue-shield-of-north-carolina": { aspectRatio: 1.66 },
"blue-cross-blue-shield-of-north-dakota": { aspectRatio: 3.05 },
"blue-cross-blue-shield-of-oklahoma": { aspectRatio: 2.25 },
"blue-cross-blue-shield-of-rhode-island": { aspectRatio: 2.00 },
"blue-cross-blue-shield-of-south-carolina": { aspectRatio: 1.83 },
"blue-cross-blue-shield-of-tennessee": { aspectRatio: 1.80 },
"blue-cross-blue-shield-of-texas": { aspectRatio: 1.91 },
"blue-cross-blue-shield-of-vermont": { aspectRatio: 1.00 },
"blue-cross-blue-shield-of-wyoming": { aspectRatio: 1.75 },
"blue-cross-complete-of-michigan": { aspectRatio: 1.00 },
"blue-cross-of-idaho-health-service": { aspectRatio: 4.92 },
"blue-medicare-advantage": { aspectRatio: 8.53 },
"blue-rx-new-york": { aspectRatio: 4.13 },
"blue-shield-of-california": { aspectRatio: 2.56 },
"bluecross-blueshield-of-south-carolina": { aspectRatio: 1.00 },
"bluecross-blueshield-of-tennessee": { aspectRatio: 1.80 },
"bmc-healthnet-plan-well-sense-health-plan": { aspectRatio: 1.00 },
"bois-forte-health-and-human-services": { aspectRatio: 0.99 },
"bon-secours-health-system": { aspectRatio: 0.99 },
"boston-children-s-hospital": { aspectRatio: 1.94 },
"boston-medical-center": { aspectRatio: 2.37 },
"boulder-community-health": { aspectRatio: 1.00 },
"boulder-medical-center": { aspectRatio: 3.76 },
"boys-town": { aspectRatio: 1.00 },
"bozeman-health": { aspectRatio: 3.37 },
"brand-new-day": { aspectRatio: 3.46 },
"braven-health": { aspectRatio: 2.46 },
"bridgespan-health-company": { aspectRatio: 1.00 },
"bridgespan": { aspectRatio: 1.00 },
"bright-health-group": { aspectRatio: 2.25 },
"bright-health": { aspectRatio: 3.66 },
"brms": { aspectRatio: 2.78 },
"broadway": { aspectRatio: 1.00 },
"brockton-neighborhood-health-center": { aspectRatio: 2.98 },
"bronson": { aspectRatio: 1.91 },
"brooklyn-health": { aspectRatio: 1.00 },
"brookwood-baptist-health": { aspectRatio: 2.72 },
"broward-community-and-family-health-centers": { aspectRatio: 1.00 },
"broward-health": { aspectRatio: 0.80 },
"bruce-w-moskowitz": { aspectRatio: 1.00 },
"bryan-health": { aspectRatio: 3.76 },
"bsa": { aspectRatio: 2.78 },
"buckeye-health-plan-mycare-ohio": { aspectRatio: 1.78 },
"buckeye-health-plan": { aspectRatio: 1.20 },
"buffalo-medical-group": { aspectRatio: 1.91 },
"burnett-medical-center": { aspectRatio: 1.33 },
"burnsville-family-physicians": { aspectRatio: 1.71 },
"butte-native-wellness": { aspectRatio: 3.05 },
"caldera-family-medicine": { aspectRatio: 3.46 },
"california-health-and-wellness": { aspectRatio: 2.06 },
"california-health-plan-imperial-valley": { aspectRatio: 1.51 },
"callen-lorde": { aspectRatio: 1.00 },
"caloptima": { aspectRatio: 1.00 },
"calviva-health": { aspectRatio: 1.00 },
"cambridge-health-alliance": { aspectRatio: 1.64 },
"cambridge-university-hospitals": { aspectRatio: 2.13 },
"camcare": { aspectRatio: 1.00 },
"cameron-health": { aspectRatio: 4.74 },
"camillus-health-concern": { aspectRatio: 2.72 },
"camino-health-center": { aspectRatio: 1.00 },
"cancer-care-northwest": { aspectRatio: 2.56 },
"cancercare-specialists": { aspectRatio: 1.91 },
"cape-cod-healthcare": { aspectRatio: 5.12 },
"cape-fear-valley": { aspectRatio: 1.00 },
"capital-bluecross": { aspectRatio: 1.91 },
"capital-district-physicians-health-plan-cdphp": { aspectRatio: 1.97 },
"capital-health-plan": { aspectRatio: 1.00 },
"care-alliance-health-center": { aspectRatio: 3.12 },
"care-evolution": { aspectRatio: 2.00 },
"care-n-care-health-plan": { aspectRatio: 2.21 },
"care-n-care": { aspectRatio: 2.21 },
"care-new-england": { aspectRatio: 1.00 },
"care1st-health-plan-arizona": { aspectRatio: 1.73 },
"carearc": { aspectRatio: 1.00 },
"careevolution": { aspectRatio: 1.91 },
"carefirst-bluecross-blueshield": { aspectRatio: 1.00 },
"carefirst-dc-medicaid": { aspectRatio: 2.13 },
"carefirst-employer-group-waiver-plan": { aspectRatio: 6.40 },
"carefirst-maryland-health-benefits-exchange": { aspectRatio: 6.40 },
"carefirst-maryland-medicaid": { aspectRatio: 2.13 },
"carefirst-medicare-advantage-dual-prime": { aspectRatio: 3.12 },
"carefirst-medicare-advantage": { aspectRatio: 3.12 },
"carelon": { aspectRatio: 3.76 },
"careoregon": { aspectRatio: 1.00 },
"carepartners-of-ct-cpct": { aspectRatio: 4.13 },
"careplus": { aspectRatio: 1.00 },
"caresource": { aspectRatio: 3.76 },
"carilion-clinic": { aspectRatio: 1.00 },
"carle": { aspectRatio: 3.76 },
"carol-milgard-breast-center": { aspectRatio: 1.00 },
"carolina-complete-health": { aspectRatio: 1.91 },
"carolina-family-health-centers": { aspectRatio: 1.64 },
"carolina-health-centers": { aspectRatio: 2.56 },
"carolinaeast-health-system": { aspectRatio: 1.00 },
"caromont-health": { aspectRatio: 2.21 },
"carson-tahoe": { aspectRatio: 1.15 },
"carson-valley-health": { aspectRatio: 2.33 },
"cascade-community-health": { aspectRatio: 1.00 },
"cascade-health-alliance": { aspectRatio: 3.37 },
"cascade-internal-medicine": { aspectRatio: 3.66 },
"cascadia-health": { aspectRatio: 2.42 },
"cass-county-health-system": { aspectRatio: 1.20 },
"catholic-health-services-of-long-island": { aspectRatio: 1.91 },
"catholic-health": { aspectRatio: 2.25 },
"cca-health-michigan": { aspectRatio: 2.61 },
"cchp": { aspectRatio: 2.91 },
"ccm-health": { aspectRatio: 2.37 },
"cedars-sinai": { aspectRatio: 3.12 },
"ceenta": { aspectRatio: 1.00 },
"cempa-community-care": { aspectRatio: 1.00 },
"cencal-health": { aspectRatio: 3.66 },
"centene-corporation": { aspectRatio: 4.00 },
"centene": { aspectRatio: 1.58 },
"centers-for-medicare-and-medicaid-services-cms-cms-medicare-gov": { aspectRatio: 2.84 },
"centers-for-medicare-and-medicaid-services-cms": { aspectRatio: 2.91 },
"centers-plan-for-healthy-living-cphl": { aspectRatio: 2.56 },
"centers-plan-healthy-living-cphl": { aspectRatio: 2.56 },
"centracare": { aspectRatio: 3.05 },
"central-california-alliance-for-health": { aspectRatio: 0.99 },
"central-city-concern": { aspectRatio: 1.00 },
"central-east-hospital-cluster": { aspectRatio: 1.83 },
"central-health-plan-of-california": { aspectRatio: 4.13 },
"central-michigan-university": { aspectRatio: 1.00 },
"central-ohio-primary-care-physicians": { aspectRatio: 3.88 },
"central-outreach-wellness-center": { aspectRatio: 0.84 },
"central-peninsula-hospital": { aspectRatio: 4.27 },
"central-surgical-associates": { aspectRatio: 2.51 },
"centralus-health": { aspectRatio: 1.78 },
"cereal-city-pediatrics": { aspectRatio: 1.00 },
"cerner": { aspectRatio: 1.00 },
"change-healthcare": { aspectRatio: 2.10 },
"chapcare": { aspectRatio: 1.00 },
"charles-b-wang-community-health-center": { aspectRatio: 4.74 },
"charles-river-community-health": { aspectRatio: 1.91 },
"cherry-hill-free-clinic": { aspectRatio: 1.00 },
"chesapeake-regional-healthcare": { aspectRatio: 2.10 },
"cheyenne-regional-medical-center": { aspectRatio: 1.36 },
"chi-franciscan-health": { aspectRatio: 1.91 },
"chi-health": { aspectRatio: 3.76 },
"chi-memorial": { aspectRatio: 2.13 },
"chi-st-alexius-health": { aspectRatio: 2.78 },
"chi-st-joseph-s-health": { aspectRatio: 3.37 },
"chi-st-vincent": { aspectRatio: 3.66 },
"child-guidance-and-family-solutions": { aspectRatio: 1.00 },
"children-s-health": { aspectRatio: 1.91 },
"children-s-healthcare-of-atlanta": { aspectRatio: 1.91 },
"children-s-heart-clinic-of-la": { aspectRatio: 2.98 },
"children-s-hospital-colorado": { aspectRatio: 0.88 },
"children-s-hospital-oakland": { aspectRatio: 2.13 },
"children-s-medical-services": { aspectRatio: 2.91 },
"children-s-nebraska": { aspectRatio: 1.00 },
"children-s-of-alabama": { aspectRatio: 2.42 },
"children-s-wisconsin": { aspectRatio: 2.06 },
"childrens-medical-services-health-plan": { aspectRatio: 2.91 },
"chinese-community-health-plan-cchp": { aspectRatio: 2.91 },
"chinese-community-health-plan": { aspectRatio: 2.91 },
"choctaw-nation": { aspectRatio: 1.78 },
"chop": { aspectRatio: 4.74 },
"chorus-community-health-plan": { aspectRatio: 5.82 },
"chorus-community-health-plans": { aspectRatio: 5.82 },
"christie-clinic": { aspectRatio: 1.00 },
"christus-health": { aspectRatio: 1.78 },
"cigna-corporation": { aspectRatio: 1.94 },
"cigna": { aspectRatio: 1.88 },
"cincinnati-children-s": { aspectRatio: 2.98 },
"ciro": { aspectRatio: 1.54 },
"citizen-potawatomi-nation": { aspectRatio: 1.00 },
"citizens-health": { aspectRatio: 1.47 },
"city-of-allentown-pennsylvania": { aspectRatio: 0.98 },
"city-of-hope": { aspectRatio: 1.83 },
"city-of-milwaukee-health-department": { aspectRatio: 1.00 },
"clackamas-county-health-centers": { aspectRatio: 3.56 },
"clark-fork-valley-hospital": { aspectRatio: 10.67 },
"clear-health-alliance": { aspectRatio: 1.80 },
"cleveland-clinic-abu-dhabi": { aspectRatio: 3.37 },
"cleveland-clinic-london": { aspectRatio: 4.27 },
"cleveland-clinic": { aspectRatio: 6.40 },
"clinica-romero": { aspectRatio: 2.42 },
"clinica-sierra-vista": { aspectRatio: 1.00 },
"cliniques-universitaires-saint-luc": { aspectRatio: 2.67 },
"clover-health": { aspectRatio: 1.91 },
"cnmri": { aspectRatio: 1.00 },
"cnsi": { aspectRatio: 4.27 },
"coast-community-health-center": { aspectRatio: 1.19 },
"coastal-carolina-health-care": { aspectRatio: 5.33 },
"codman-square-health-center": { aspectRatio: 1.00 },
"cody-regional-health": { aspectRatio: 2.84 },
"collective-health": { aspectRatio: 3.05 },
"colonial-life-always-assist": { aspectRatio: 1.91 },
"colonial-voluntary-benefits-always-assist": { aspectRatio: 2.42 },
"colorado-access": { aspectRatio: 1.91 },
"colorado-state-medicaid-health-first": { aspectRatio: 3.05 },
"columbia-basin-hospital": { aspectRatio: 1.32 },
"columbia-community-mental-health": { aspectRatio: 1.00 },
"columbia-gorge-family-medicine": { aspectRatio: 1.02 },
"columbia-river-health": { aspectRatio: 1.00 },
"columbia-university-irving-medical-center": { aspectRatio: 3.37 },
"columbus-regional-health": { aspectRatio: 0.88 },
"common-ground-healthcare-cooperative": { aspectRatio: 1.73 },
"commonspirit-gakytntx": { aspectRatio: 2.29 },
"commonspirit-health": { aspectRatio: 2.29 },
"commonspirit-mountain-region": { aspectRatio: 4.13 },
"commonwealth-care-alliance": { aspectRatio: 2.56 },
"communicare-advantage": { aspectRatio: 1.00 },
"communicare-ole": { aspectRatio: 5.33 },
"community-care-health-plan-inc": { aspectRatio: 4.13 },
"community-care-health-plan-wi": { aspectRatio: 1.33 },
"community-care-health-plan": { aspectRatio: 4.13 },
"community-care-of-oklahoma": { aspectRatio: 1.00 },
"community-care-plan": { aspectRatio: 1.00 },
"community-first-medical-center": { aspectRatio: 1.00 },
"community-health-care-inc": { aspectRatio: 3.76 },
"community-health-center-of-fort-dodge": { aspectRatio: 2.56 },
"community-health-center-of-franklin-county": { aspectRatio: 1.00 },
"community-health-center-of-lubbock": { aspectRatio: 2.33 },
"community-health-center-of-southeastern-iowa": { aspectRatio: 1.00 },
"community-health-connections": { aspectRatio: 1.00 },
"community-health-group-chg": { aspectRatio: 1.83 },
"community-health-group": { aspectRatio: 4.74 },
"community-health-network-of-washington": { aspectRatio: 1.60 },
"community-health-network": { aspectRatio: 4.13 },
"community-health-of-central-washington": { aspectRatio: 3.37 },
"community-health-of-south-florida": { aspectRatio: 1.88 },
"community-health-partners": { aspectRatio: 1.00 },
"community-health-plan-of-washington-chpw": { aspectRatio: 2.61 },
"community-health-systems": { aspectRatio: 5.33 },
"community-hospital-for-anaconda": { aspectRatio: 1.00 },
"community-medical-centers": { aspectRatio: 1.51 },
"community-memorial-healthcare": { aspectRatio: 2.78 },
"community-memorial-hospital": { aspectRatio: 2.78 },
"community-mental-health-affiliates": { aspectRatio: 3.28 },
"communitycare-plan": { aspectRatio: 2.98 },
"communitycare": { aspectRatio: 1.00 },
"commwell-health": { aspectRatio: 1.75 },
"companion-life": { aspectRatio: 2.06 },
"compassionate-care-medical-center": { aspectRatio: 1.01 },
"complete-cardiovascular-care": { aspectRatio: 1.42 },
"concentra": { aspectRatio: 1.00 },
"concierge-health-partners": { aspectRatio: 1.00 },
"cone-health": { aspectRatio: 1.51 },
"conemaugh-health-system": { aspectRatio: 1.00 },
"confluence-health": { aspectRatio: 2.00 },
"connect-pbc": { aspectRatio: 2.29 },
"connecticare": { aspectRatio: 1.91 },
"connecticut-children-s-medical-center": { aspectRatio: 3.05 },
"connecticut-ear-nose-and-throat-associates": { aspectRatio: 3.12 },
"connecticut-gi": { aspectRatio: 0.99 },
"connecticut-medicaid": { aspectRatio: 1.80 },
"connecticut-orthopaedics": { aspectRatio: 4.41 },
"connecticut-state-medicaid": { aspectRatio: 1.02 },
"contra-costa-health-plan": { aspectRatio: 1.00 },
"contra-costa-health-services": { aspectRatio: 1.31 },
"cook-children-s-health-plan-cchp": { aspectRatio: 2.56 },
"cook-children-s-health-plan": { aspectRatio: 2.56 },
"cook-children-s": { aspectRatio: 3.76 },
"cook-county-health-countycare": { aspectRatio: 1.33 },
"cook-county-health-morecare": { aspectRatio: 3.76 },
"cooper": { aspectRatio: 3.46 },
"coordinated-care-of-washington-inc": { aspectRatio: 3.46 },
"corewell-health-west": { aspectRatio: 3.12 },
"coteau-des-prairie-medical-center": { aspectRatio: 2.00 },
"cottage-health-system": { aspectRatio: 2.51 },
"county-of-san-mateo": { aspectRatio: 1.91 },
"countycare-health-plan": { aspectRatio: 2.06 },
"covenant-health-and-grace-clinic": { aspectRatio: 1.78 },
"covenant-health": { aspectRatio: 2.42 },
"covenant-healthcare": { aspectRatio: 2.17 },
"cox-health-plans-marketplace-exchange": { aspectRatio: 2.21 },
"cox-healthplans-medicare-advantage": { aspectRatio: 1.91 },
"cox-healthplans": { aspectRatio: 2.21 },
"credena-health-alaska": { aspectRatio: 3.88 },
"credena-health-washingtonmontana": { aspectRatio: 3.88 },
"credena-health": { aspectRatio: 1.00 },
"crescent-community-health-center": { aspectRatio: 1.00 },
"crossing-rivers-health-november-1-2022-and-after": { aspectRatio: 1.00 },
"csc-pace-center": { aspectRatio: 2.17 },
"culicchia-neurological": { aspectRatio: 2.98 },
"curana-allyalign": { aspectRatio: 3.46 },
"curana-health-allyalign": { aspectRatio: 3.46 },
"curry-health-network": { aspectRatio: 4.57 },
"cuyuna-regional-medical-center": { aspectRatio: 3.05 },
"cvs-caremark": { aspectRatio: 1.00 },
"dap": { aspectRatio: 1.78 },
"dartmouth": { aspectRatio: 3.56 },
"davita-physician-solutions": { aspectRatio: 1.56 },
"dayton-children-s-hospital": { aspectRatio: 1.03 },
"dco-public-health": { aspectRatio: 1.20 },
"deaconess": { aspectRatio: 1.86 },
"dean-aso-plans-only": { aspectRatio: 1.00 },
"dean-health-plan": { aspectRatio: 1.00 },
"dean-medicare-plans": { aspectRatio: 1.00 },
"dedicated-to-women": { aspectRatio: 2.61 },
"delaware-first-health": { aspectRatio: 1.51 },
"delaware-medicaid": { aspectRatio: 1.00 },
"delaware-state-medicaid": { aspectRatio: 1.00 },
"dell-children-s-health-plan": { aspectRatio: 1.00 },
"delta-dental": { aspectRatio: 9.14 },
"dental-select": { aspectRatio: 1.91 },
"dentaquest-dental-care-plus-group": { aspectRatio: 1.00 },
"dentaquest": { aspectRatio: 1.91 },
"denver-health-medical-plan": { aspectRatio: 1.00 },
"denver-health": { aspectRatio: 1.13 },
"department-of-veteran-s-affairs": { aspectRatio: 2.61 },
"department-of-veterans-affairs": { aspectRatio: 2.61 },
"devoted-health": { aspectRatio: 1.80 },
"dickson-medical-associates": { aspectRatio: 1.00 },
"digestive-specialists-pa": { aspectRatio: 1.00 },
"district-health-care-services": { aspectRatio: 1.00 },
"district-one-hospital": { aspectRatio: 1.64 },
"doctors-healthcare-plans": { aspectRatio: 1.00 },
"doctors-on-duty": { aspectRatio: 1.51 },
"dominion-national": { aspectRatio: 1.00 },
"dothouse-health": { aspectRatio: 1.00 },
"douglas-county-hospital": { aspectRatio: 1.00 },
"douglas-county-memorial-hospital": { aspectRatio: 5.82 },
"drexel": { aspectRatio: 2.78 },
"dreyer": { aspectRatio: 1.00 },
"driscoll-children-s-hospital": { aspectRatio: 3.37 },
"driscoll-health-plan": { aspectRatio: 3.05 },
"dubai-health": { aspectRatio: 3.76 },
"duffy-health-center": { aspectRatio: 2.25 },
"duke-university-health-system": { aspectRatio: 4.41 },
"duly-health-and-care": { aspectRatio: 1.56 },
"dupage-medical-group": { aspectRatio: 1.00 },
"eagle-view-community-health-center": { aspectRatio: 2.00 },
"ear-nose-and-throat-surgical": { aspectRatio: 1.47 },
"east-adams-rural-hospital": { aspectRatio: 2.42 },
"east-cascade-women-s-group": { aspectRatio: 2.03 },
"east-suffolk-and-north-essex-nhs-foundation-trust": { aspectRatio: 1.00 },
"eau-claire-gi-associates-oakleaf-medical-network": { aspectRatio: 1.91 },
"ebaandm": { aspectRatio: 2.51 },
"eclinicalworks": { aspectRatio: 1.00 },
"ecu-health": { aspectRatio: 2.25 },
"eisenhower-health": { aspectRatio: 6.10 },
"el-camino-hospital": { aspectRatio: 2.42 },
"el-camino": { aspectRatio: 1.91 },
"el-centro-de-corazon": { aspectRatio: 4.41 },
"el-rio-health": { aspectRatio: 2.10 },
"elevance-prod-new": { aspectRatio: 1.78 },
"elevance-test": { aspectRatio: 1.78 },
"elevated-community-health": { aspectRatio: 1.00 },
"elica-health-centers": { aspectRatio: 2.78 },
"elisabeth-tweesteden-ziekenhuis": { aspectRatio: 1.38 },
"ely-bloomenson-community-hospital": { aspectRatio: 1.73 },
"emblem-health-connecticare": { aspectRatio: 1.91 },
"emblem-health": { aspectRatio: 6.40 },
"emblemhealth": { aspectRatio: 6.40 },
"emi-health": { aspectRatio: 3.88 },
"emory-healthcare": { aspectRatio: 2.91 },
"empire-bluecross-blueshield-medicaid": { aspectRatio: 1.00 },
"empire-bluecross-blueshield": { aspectRatio: 2.33 },
"emplify-health": { aspectRatio: 1.78 },
"empower-health": { aspectRatio: 1.78 },
"empower-u": { aspectRatio: 0.80 },
"endeavor-health": { aspectRatio: 5.12 },
"endoscopy-center-of-connecticut": { aspectRatio: 1.94 },
"englewood": { aspectRatio: 1.00 },
"enloe-medical-center": { aspectRatio: 2.91 },
"enlyte": { aspectRatio: 2.00 },
"epic-mychart": { aspectRatio: 5.82 },
"epic": { aspectRatio: 2.56 },
"equitas-health": { aspectRatio: 1.91 },
"eranga-cardiology": { aspectRatio: 5.82 },
"erlanger-health-system": { aspectRatio: 1.51 },
"eskenazi": { aspectRatio: 1.33 },
"essence-healthcare": { aspectRatio: 1.83 },
"essentia-health": { aspectRatio: 5.12 },
"etsu-health": { aspectRatio: 1.00 },
"evangelical-community-hospital": { aspectRatio: 1.00 },
"evara-health": { aspectRatio: 3.20 },
"everett-bone-and-joint": { aspectRatio: 2.78 },
"evergreen-surgical-oakleaf-medical-network": { aspectRatio: 2.00 },
"evergreenhealth": { aspectRatio: 2.72 },
"evernorth-care-group": { aspectRatio: 1.00 },
"evernorth-home-based-care": { aspectRatio: 1.78 },
"evernorth-workplace-care": { aspectRatio: 1.00 },
"exact-sciences": { aspectRatio: 2.00 },
"excellus-bluecross-blueshield-medicare": { aspectRatio: 5.57 },
"excellus-bluecross-blueshield": { aspectRatio: 5.57 },
"excelsior-family-medicine": { aspectRatio: 2.78 },
"experience-health": { aspectRatio: 3.05 },
"express-scripts": { aspectRatio: 1.88 },
"eyemed": { aspectRatio: 1.33 },
"fairchild-medical-center": { aspectRatio: 4.41 },
"fairview-range": { aspectRatio: 1.00 },
"fall-creek-internal-medicine": { aspectRatio: 2.98 },
"fallon-health": { aspectRatio: 3.66 },
"family-and-aging-center": { aspectRatio: 1.00 },
"family-care-health-centers-of-st-louis": { aspectRatio: 2.29 },
"family-care-network": { aspectRatio: 6.10 },
"family-health-center-of-marshfield": { aspectRatio: 1.00 },
"family-health-center-of-worcester": { aspectRatio: 1.28 },
"family-health-center": { aspectRatio: 0.93 },
"family-health-centers": { aspectRatio: 2.67 },
"family-health-west": { aspectRatio: 2.29 },
"family-healthcare": { aspectRatio: 1.00 },
"family-medical-group": { aspectRatio: 1.42 },
"fastmed": { aspectRatio: 4.41 },
"father-joe-s-villages": { aspectRatio: 1.00 },
"fenway-health": { aspectRatio: 1.00 },
"fidelis-care": { aspectRatio: 1.00 },
"first-choice-health": { aspectRatio: 1.47 },
"first-choice-vip-care-plus": { aspectRatio: 3.37 },
"first-choice-vip-care": { aspectRatio: 3.37 },
"first-medical-health-plan": { aspectRatio: 1.00 },
"first-state-infectious-diseases": { aspectRatio: 1.51 },
"firstcare": { aspectRatio: 2.98 },
"firstcarolinacare-insurance-company": { aspectRatio: 1.00 },
"firstcarolinacare": { aspectRatio: 1.00 },
"firsthealth-of-the-carolinas": { aspectRatio: 3.66 },
"flexpa-live-mode-sample-patient": { aspectRatio: 3.05 },
"flexpa-test-mode-sample-patient": { aspectRatio: 3.05 },
"florida-advanced-gastroenterology-center": { aspectRatio: 0.83 },
"florida-blue": { aspectRatio: 1.00 },
"florida-community-care-health-plan": { aspectRatio: 3.88 },
"florida-community-health-centers": { aspectRatio: 3.66 },
"florida-complete-care": { aspectRatio: 3.76 },
"florida-health-care-plan": { aspectRatio: 4.13 },
"florida-health-care-plans": { aspectRatio: 4.13 },
"foo-healthplan": { aspectRatio: 2.78 },
"foot-and-ankle-clinic-oakleaf-medical-network": { aspectRatio: 2.84 },
"foothill-family-clinic": { aspectRatio: 1.88 },
"foundcare": { aspectRatio: 2.25 },
"franciscan-alliance": { aspectRatio: 3.88 },
"franciscan-children-s-hospital": { aspectRatio: 2.13 },
"franciscan-healthconnect": { aspectRatio: 1.75 },
"franklin-primary-health-center": { aspectRatio: 2.91 },
"freedom-health": { aspectRatio: 2.78 },
"friends-of-family-health-center": { aspectRatio: 1.00 },
"frimley-health-foundation-nhs-trust": { aspectRatio: 1.91 },
"froedtert-south": { aspectRatio: 1.00 },
"froedtert": { aspectRatio: 3.12 },
"full-circle-health": { aspectRatio: 2.84 },
"gardner-health-services": { aspectRatio: 3.05 },
"garnet-health": { aspectRatio: 0.99 },
"geisinger-health-plan": { aspectRatio: 2.72 },
"geisinger": { aspectRatio: 1.91 },
"genesis-community-health": { aspectRatio: 3.12 },
"genesis": { aspectRatio: 3.46 },
"gentle-pediatrics": { aspectRatio: 1.01 },
"georgia-department-of-community-health": { aspectRatio: 1.00 },
"georgia-health-advantage": { aspectRatio: 4.57 },
"georgia-medicaid": { aspectRatio: 1.86 },
"georgia-state-medicaid": { aspectRatio: 2.10 },
"gerald-l-ignace-indian-health-center": { aspectRatio: 0.98 },
"ghc": { aspectRatio: 3.46 },
"glencoe-regional-health-services": { aspectRatio: 3.66 },
"globalhealth-holdings": { aspectRatio: 2.03 },
"globalhealth": { aspectRatio: 2.03 },
"go-east-medical-services": { aspectRatio: 1.33 },
"gohealth-urgent-care": { aspectRatio: 2.10 },
"golden-valley-health-centers": { aspectRatio: 1.00 },
"goldenshore-medical": { aspectRatio: 1.00 },
"good-samaritan": { aspectRatio: 1.49 },
"grace-health": { aspectRatio: 2.78 },
"grace-medical-home": { aspectRatio: 1.00 },
"gracelight-community-health": { aspectRatio: 1.00 },
"grady-health-system": { aspectRatio: 3.20 },
"grande-ronde": { aspectRatio: 1.60 },
"granted": { aspectRatio: 1.00 },
"great-ormond-street-hospital": { aspectRatio: 1.97 },
"greater-baltimore-medical-center": { aspectRatio: 1.00 },
"greater-orange-county-ear-nose-throat-head-and-neck-surgeons": { aspectRatio: 4.00 },
"gritman-medical-center": { aspectRatio: 1.91 },
"group-health-cooperative-of-eau-claire": { aspectRatio: 2.67 },
"group-health-cooperative-of-south-central-wisconsin": { aspectRatio: 1.00 },
"guardian-life": { aspectRatio: 1.88 },
"guthrie": { aspectRatio: 3.88 },
"guy-s-and-st-thomas": { aspectRatio: 2.91 },
"gw-university-medical-faculty-associates": { aspectRatio: 6.40 },
"habitat-health-pace": { aspectRatio: 5.33 },
"habitat-health": { aspectRatio: 1.91 },
"hackensack-meridian-health": { aspectRatio: 3.37 },
"hally": { aspectRatio: 2.03 },
"hamaspik-choice": { aspectRatio: 1.00 },
"hamaspik-medicare-select": { aspectRatio: 1.42 },
"hamilton-health-sciences": { aspectRatio: 2.84 },
"hannibal-regional-healthcare-system": { aspectRatio: 1.86 },
"harbor-health": { aspectRatio: 1.91 },
"harmony-health-medical-clinic": { aspectRatio: 2.25 },
"harmony": { aspectRatio: 3.88 },
"harney-district-hospital": { aspectRatio: 1.42 },
"harris-county-public-health": { aspectRatio: 1.58 },
"hartford-healthcare": { aspectRatio: 2.17 },
"harvard-pilgrim-health-care": { aspectRatio: 2.84 },
"harvard-pilgrim": { aspectRatio: 2.84 },
"hattiesburg": { aspectRatio: 1.00 },
"hawaii-island-community-health-center": { aspectRatio: 4.92 },
"hawaii-medical-service-association": { aspectRatio: 1.00 },
"hawaii-medical-services-association": { aspectRatio: 1.00 },
"hawaii-pacific-health": { aspectRatio: 2.67 },
"hayward-medical-center": { aspectRatio: 2.46 },
"hca": { aspectRatio: 2.13 },
"hchd": { aspectRatio: 1.88 },
"head-and-neck-associates-of-orange-county": { aspectRatio: 1.00 },
"health-alliance-plan": { aspectRatio: 2.33 },
"health-alliance": { aspectRatio: 2.67 },
"health-and-social-care-northern-ireland": { aspectRatio: 3.05 },
"health-care-service-corporation-medicare-non-blues": { aspectRatio: 2.67 },
"health-center-powered-by-mount-sinai": { aspectRatio: 3.76 },
"health-first-colorado": { aspectRatio: 3.05 },
"health-first-family-care-center": { aspectRatio: 2.67 },
"health-first-health-plans-of-florida": { aspectRatio: 3.76 },
"health-first-health-plans": { aspectRatio: 3.76 },
"health-first": { aspectRatio: 1.91 },
"health-net-cal-mediconnect-plan": { aspectRatio: 2.06 },
"health-net-community-solutions-medi-cal": { aspectRatio: 2.06 },
"health-new-england": { aspectRatio: 2.78 },
"health-partners-plans": { aspectRatio: 2.61 },
"health-plan-of-nevada": { aspectRatio: 2.33 },
"health-plan-of-san-joaquin": { aspectRatio: 2.51 },
"health-plan-of-san-mateo": { aspectRatio: 1.00 },
"health-plan-san-mateo-hpsm": { aspectRatio: 2.46 },
"health-plans-inc": { aspectRatio: 1.00 },
"health-ventures": { aspectRatio: 2.84 },
"healthcare-for-the-homeless-houston": { aspectRatio: 1.00 },
"healthez": { aspectRatio: 3.88 },
"healthfirst": { aspectRatio: 1.91 },
"healthgram": { aspectRatio: 3.76 },
"healthlx": { aspectRatio: 5.57 },
"healthnet-egwp": { aspectRatio: 2.10 },
"healthnow-administrative-services": { aspectRatio: 1.00 },
"healthpartners": { aspectRatio: 3.76 },
"healthpoint": { aspectRatio: 1.86 },
"healthright-360": { aspectRatio: 1.00 },
"healthscope": { aspectRatio: 1.21 },
"healthspring": { aspectRatio: 1.88 },
"healthsun-test": { aspectRatio: 2.21 },
"healthsun": { aspectRatio: 2.21 },
"healthteam-advantage-hta": { aspectRatio: 3.88 },
"healthy-blue-blue-choice": { aspectRatio: 1.00 },
"healthy-blue-la-medicaid": { aspectRatio: 2.84 },
"healthy-blue-la": { aspectRatio: 2.84 },
"healthy-blue-mo-medicaid": { aspectRatio: 1.00 },
"healthy-blue-mo": { aspectRatio: 1.00 },
"healthy-blue-nc-medicaid": { aspectRatio: 10.67 },
"healthy-blue-nc": { aspectRatio: 1.00 },
"healthy-blue-ne": { aspectRatio: 1.00 },
"healthy-blue-sc": { aspectRatio: 1.00 },
"healthy-blue": { aspectRatio: 1.00 },
"healthy-living-heart-and-vein": { aspectRatio: 1.00 },
"healthy-mississippi": { aspectRatio: 3.37 },
"heart-of-ohio-family-health": { aspectRatio: 1.00 },
"heart-of-texas": { aspectRatio: 1.00 },
"heartland-health-services": { aspectRatio: 1.00 },
"helen-newberry-joy": { aspectRatio: 1.00 },
"helse-midt-norge": { aspectRatio: 6.10 },
"hemophilia-outreach-center": { aspectRatio: 3.37 },
"hendricks-regional-health": { aspectRatio: 2.56 },
"hennepin-health": { aspectRatio: 2.67 },
"hennepin": { aspectRatio: 2.67 },
"henry-ford-health": { aspectRatio: 1.78 },
"heritage-pace": { aspectRatio: 2.17 },
"highland-district-hospital": { aspectRatio: 1.00 },
"highland-health-providers": { aspectRatio: 1.91 },
"highmark-bcbs-of-western-new-york": { aspectRatio: 5.33 },
"highmark-blueshield-of-northeastern-new-york": { aspectRatio: 2.06 },
"highmark-health": { aspectRatio: 3.46 },
"highmark-of-northeastern-new-york": { aspectRatio: 2.06 },
"highmark": { aspectRatio: 1.91 },
"hill-physicians-medical-group": { aspectRatio: 1.97 },
"hillcrest": { aspectRatio: 1.91 },
"hillsdale-hospital": { aspectRatio: 3.12 },
"hilltown-community-health-center": { aspectRatio: 6.74 },
"hoag-memorial-hospital-presbyterian": { aspectRatio: 2.03 },
"hocking-valley": { aspectRatio: 1.80 },
"holyoke-health": { aspectRatio: 1.00 },
"home-state-health-plan": { aspectRatio: 1.00 },
"homestead-community-health-center": { aspectRatio: 2.61 },
"hometown-health-clinic": { aspectRatio: 5.12 },
"hometown-health-plan": { aspectRatio: 3.37 },
"honor-health": { aspectRatio: 4.27 },
"hope-digestive-and-liver-disease-clinic": { aspectRatio: 3.66 },
"horizon-blue-cross-blue-shield-of-new-jersey": { aspectRatio: 1.91 },
"horizon-pace": { aspectRatio: 2.17 },
"hospital-for-special-surgery": { aspectRatio: 1.00 },
"hospital-sisters-health-system": { aspectRatio: 2.91 },
"hot-springs-health-program": { aspectRatio: 2.42 },
"houston-foot-and-ankle-professional-group": { aspectRatio: 0.99 },
"houston-methodist": { aspectRatio: 2.61 },
"howard-brown-health": { aspectRatio: 3.05 },
"hpi": { aspectRatio: 1.49 },
"hshs-medical-group": { aspectRatio: 3.76 },
"humana-military": { aspectRatio: 1.00 },
"humana": { aspectRatio: 1.78 },
"huntington-hospital": { aspectRatio: 1.66 },
"hurley-medical-center": { aspectRatio: 2.00 },
"hutchinson-health": { aspectRatio: 1.00 },
"iaff-magnacare": { aspectRatio: 1.91 },
"iba": { aspectRatio: 2.61 },
"idaho-health-and-welfare": { aspectRatio: 6.40 },
"idaho-state-medicaid": { aspectRatio: 1.00 },
"igo-medical-group": { aspectRatio: 2.98 },
"illinois-bone-and-joint-institute": { aspectRatio: 2.67 },
"ima-healthcare": { aspectRatio: 3.05 },
"imagine360": { aspectRatio: 1.38 },
"inclusa": { aspectRatio: 1.47 },
"independence-blue-cross": { aspectRatio: 8.00 },
"independence": { aspectRatio: 1.80 },
"independent-care-health-plan": { aspectRatio: 1.00 },
"independent-health-association": { aspectRatio: 2.29 },
"independent-health": { aspectRatio: 2.29 },
"indian-health-board-of-minneapolis": { aspectRatio: 1.00 },
"indian-health-center-of-santa-clara-valley": { aspectRatio: 1.80 },
"indian-health-council": { aspectRatio: 1.00 },
"indian-health-service": { aspectRatio: 1.01 },
"indiana-university-health-plans": { aspectRatio: 1.00 },
"infectious-disease-associates-of-naples": { aspectRatio: 2.21 },
"infinity-health-care": { aspectRatio: 2.25 },
"infirmary": { aspectRatio: 1.00 },
"inland-empire-health-plan": { aspectRatio: 2.33 },
"innovaccer-consented": { aspectRatio: 1.91 },
"innovaccer": { aspectRatio: 2.00 },
"innovage": { aspectRatio: 1.91 },
"innovation-health": { aspectRatio: 2.21 },
"innovista-medical-center": { aspectRatio: 1.91 },
"inova-health-system": { aspectRatio: 1.78 },
"inovalon": { aspectRatio: 1.00 },
"insel-gruppe": { aspectRatio: 4.41 },
"integris-health": { aspectRatio: 1.00 },
"integris-physician-group": { aspectRatio: 1.00 },
"intercommunity-health-care": { aspectRatio: 2.98 },
"intermountain-health": { aspectRatio: 3.28 },
"international-health-community-services": { aspectRatio: 1.00 },
"interopstation": { aspectRatio: 1.97 },
"intersystems": { aspectRatio: 1.78 },
"iowa-specialty-hospitals-and-clinics": { aspectRatio: 1.00 },
"iowa-total-care": { aspectRatio: 1.51 },
"iridescent-health": { aspectRatio: 2.13 },
"island-health-care": { aspectRatio: 1.66 },
"itasca-medical-care": { aspectRatio: 3.66 },
"jacobson-memorial-hospital": { aspectRatio: 2.29 },
"jamestown-family-health-clinic": { aspectRatio: 1.01 },
"jamestown-regional-medical-center": { aspectRatio: 2.91 },
"jane-pauley-community-health-center": { aspectRatio: 1.00 },
"jefferson-county-health-center": { aspectRatio: 1.00 },
"jefferson-health-plans": { aspectRatio: 1.44 },
"jefferson-healthcare": { aspectRatio: 2.67 },
"jessie-trice-community-health-system": { aspectRatio: 2.91 },
"jewish-community-free-clinic": { aspectRatio: 1.41 },
"john-muir-health": { aspectRatio: 5.12 },
"johnny-blanchard-md": { aspectRatio: 1.11 },
"johns-hopkins-advantage-md": { aspectRatio: 1.00 },
"johns-hopkins-aramco-healthcare": { aspectRatio: 3.46 },
"johns-hopkins-medicine": { aspectRatio: 1.39 },
"johnson-memorial-health-services": { aspectRatio: 1.00 },
"jordan-valley-community-health-center": { aspectRatio: 2.98 },
"jps-health-network": { aspectRatio: 3.46 },
"jupiter-medical-center": { aspectRatio: 2.25 },
"jw-family-medicine": { aspectRatio: 2.91 },
"kadlec-health-system": { aspectRatio: 2.98 },
"kahuku-medical-center": { aspectRatio: 1.00 },
"kaiser-foundation-health-plan-of-colorado": { aspectRatio: 1.78 },
"kaiser-foundation-health-plan-of-georgia": { aspectRatio: 1.00 },
"kaiser-foundation-health-plan-of-hawaii": { aspectRatio: 1.78 },
"kaiser-foundation-health-plan-of-the-mid-atlantic-states": { aspectRatio: 2.56 },
"kaiser-foundation-health-plan-of-the-northwest": { aspectRatio: 3.66 },
"kaiser-foundation-health-plan-of-washington": { aspectRatio: 2.00 },
"kaiser-permanente": { aspectRatio: 1.60 },
"kalamazoo-college": { aspectRatio: 0.95 },
"kalamazoo-foot-surgery": { aspectRatio: 1.01 },
"kansas-health-advantage": { aspectRatio: 3.76 },
"kansas-medical-assistance-program-kmap": { aspectRatio: 1.88 },
"kansas-state-medicaid-kmap": { aspectRatio: 1.62 },
"kelsey-seybold": { aspectRatio: 1.00 },
"kelseycare-advantage": { aspectRatio: 1.49 },
"kennedy-krieger-institute": { aspectRatio: 1.73 },
"kenosha-community-health-center": { aspectRatio: 1.00 },
"kentucky-medicaid": { aspectRatio: 1.00 },
"kettering": { aspectRatio: 3.56 },
"keycare": { aspectRatio: 5.12 },
"keystone-first-vip-choice": { aspectRatio: 2.78 },
"keystone-first": { aspectRatio: 1.00 },
"keystone-firstcommunity-healthchoices": { aspectRatio: 3.66 },
"keystone-health": { aspectRatio: 2.42 },
"khumalo-foot-and-ankle-clinic": { aspectRatio: 0.86 },
"kids-first-pediatrics": { aspectRatio: 1.00 },
"king-county-public-health": { aspectRatio: 0.95 },
"king-fahad-medical-city": { aspectRatio: 1.00 },
"king-s-college-hospital": { aspectRatio: 3.12 },
"kintegra-health": { aspectRatio: 2.84 },
"kinwell": { aspectRatio: 3.88 },
"kittson-healthcare": { aspectRatio: 1.04 },
"ko-kwel-wellness-center": { aspectRatio: 3.37 },
"kootenai-health": { aspectRatio: 3.66 },
"l-a-care-health-plan": { aspectRatio: 0.75 },
"l-a-care": { aspectRatio: 0.75 },
"la-casa-family-health-centers": { aspectRatio: 1.00 },
"la-clinica": { aspectRatio: 3.20 },
"la-esperanza-clinic": { aspectRatio: 1.49 },
"la-pine-community-health-center": { aspectRatio: 1.91 },
"laguna-beach": { aspectRatio: 3.37 },
"lake-charles-memorial-health-system": { aspectRatio: 4.92 },
"lake-region-healthcare": { aspectRatio: 3.46 },
"lakeland-care": { aspectRatio: 1.73 },
"lakeland-healthcare": { aspectRatio: 1.00 },
"lakeland-regional-health": { aspectRatio: 3.46 },
"lakeshore-community-health-center": { aspectRatio: 3.66 },
"lakewood-health-system": { aspectRatio: 2.98 },
"lallie-kemp-regional-medical-center": { aspectRatio: 2.61 },
"lancaster": { aspectRatio: 1.52 },
"lane-regional-medical-center": { aspectRatio: 4.00 },
"lawndale-christian-health-center": { aspectRatio: 4.27 },
"lcmc-health": { aspectRatio: 1.91 },
"lead-north-llc": { aspectRatio: 1.00 },
"lee-memorial-health-system": { aspectRatio: 3.20 },
"legacy-community-health": { aspectRatio: 4.92 },
"legacy-health-system": { aspectRatio: 0.62 },
"lehigh-valley-health-network": { aspectRatio: 3.46 },
"leon-medical-centers": { aspectRatio: 3.46 },
"lexington-county-health-services": { aspectRatio: 2.46 },
"liberty-dental-plan": { aspectRatio: 2.00 },
"licking-memorial-health-system": { aspectRatio: 1.00 },
"lifecare-alliance": { aspectRatio: 1.00 },
"lifelong-medical": { aspectRatio: 1.28 },
"lifescape": { aspectRatio: 1.00 },
"lifespan": { aspectRatio: 2.29 },
"lincoln-hospital-and-clinics": { aspectRatio: 2.56 },
"lindner-center-of-hope": { aspectRatio: 1.78 },
"linton-regional-medical-center": { aspectRatio: 2.61 },
"localhost-insurance": { aspectRatio: 2.42 },
"logica-health": { aspectRatio: 1.86 },
"loma-linda-university-health-pace": { aspectRatio: 2.17 },
"loma-linda-university-health": { aspectRatio: 1.25 },
"loma-linda": { aspectRatio: 1.25 },
"longstreet-clinic": { aspectRatio: 5.33 },
"louisiana-blue": { aspectRatio: 1.00 },
"louisiana-healthcare-connections": { aspectRatio: 2.06 },
"louisiana-medicaid": { aspectRatio: 1.91 },
"louisiana-orthopaedic-specialists": { aspectRatio: 1.00 },
"lovelace-health": { aspectRatio: 2.84 },
"lowell-community-health-center": { aspectRatio: 1.01 },
"lower-lights-christian-health-center": { aspectRatio: 5.57 },
"loyola-medicine": { aspectRatio: 1.00 },
"lsu-health-network": { aspectRatio: 3.20 },
"lucent-health": { aspectRatio: 5.12 },
"lumina": { aspectRatio: 1.00 },
"luminare-health": { aspectRatio: 2.84 },
"luminis-health": { aspectRatio: 2.84 },
"lummi-tribal-health-center": { aspectRatio: 1.00 },
"luzerner-kantonsspital": { aspectRatio: 1.00 },
"lynn-community-health-center": { aspectRatio: 1.66 },
"lyon-martin": { aspectRatio: 3.28 },
"m-health-fairview": { aspectRatio: 1.00 },
"maastricht-umc": { aspectRatio: 4.00 },
"macie-medical": { aspectRatio: 2.67 },
"mackenzie-health": { aspectRatio: 1.97 },
"mackinac-straits-health-system": { aspectRatio: 2.25 },
"madison-health": { aspectRatio: 5.82 },
"madison-regional-health-system": { aspectRatio: 3.12 },
"madison-ridgeland-medical-clinic": { aspectRatio: 4.74 },
"maestro-health": { aspectRatio: 1.00 },
"maeville-pediatrics": { aspectRatio: 1.00 },
"magellan-assist": { aspectRatio: 3.76 },
"magnacare": { aspectRatio: 1.91 },
"magnolia-health": { aspectRatio: 1.51 },
"magnolia-lane-pediatrics": { aspectRatio: 1.62 },
"mahnomen-health-center": { aspectRatio: 3.12 },
"main-line-health": { aspectRatio: 8.53 },
"maine-state-medicaid-mainecare": { aspectRatio: 1.51 },
"mainecare": { aspectRatio: 1.51 },
"mainehealth": { aspectRatio: 2.00 },
"malama-i-ke-ola-health-center": { aspectRatio: 3.56 },
"managed-health-services-mhs": { aspectRatio: 1.00 },
"manchester-foundation-trust": { aspectRatio: 3.28 },
"maple-city-health-care-center": { aspectRatio: 1.91 },
"maren-medical-group": { aspectRatio: 1.00 },
"marin-community-clinic": { aspectRatio: 3.05 },
"marpai-health": { aspectRatio: 3.88 },
"marshall-medical-center": { aspectRatio: 2.56 },
"martin-s-point-health-care": { aspectRatio: 3.56 },
"martin-s-point": { aspectRatio: 3.56 },
"mary-free-bed": { aspectRatio: 2.91 },
"mary-washington": { aspectRatio: 1.00 },
"maryland-health-connections": { aspectRatio: 4.13 },
"maryland-physicians-care": { aspectRatio: 1.00 },
"maryland-primary-care-physicians": { aspectRatio: 1.01 },
"maryland-state-medicaid": { aspectRatio: 3.56 },
"mass-advantage": { aspectRatio: 2.84 },
"mass-general-brigham-health-plan": { aspectRatio: 1.91 },
"mass-general-brigham": { aspectRatio: 6.10 },
"massachusetts-state-medicaid-masshealth": { aspectRatio: 1.97 },
"mayo-clinic": { aspectRatio: 0.91 },
"mcam": { aspectRatio: 1.00 },
"mchc-health-centers": { aspectRatio: 3.76 },
"mckenzie-county-healthcare": { aspectRatio: 1.00 },
"mclaren-health-plan": { aspectRatio: 1.00 },
"mclaren-mdwise": { aspectRatio: 1.00 },
"mcleod-health": { aspectRatio: 1.71 },
"mcs-puerto-rico": { aspectRatio: 1.91 },
"mea-medical-clinic": { aspectRatio: 1.44 },
"med-centro": { aspectRatio: 2.29 },
"medica": { aspectRatio: 5.33 },
"medical-card-system": { aspectRatio: 1.91 },
"medical-clinic-of-houston-l-l-p": { aspectRatio: 1.00 },
"medical-mutual-of-ohio": { aspectRatio: 6.40 },
"medicare": { aspectRatio: 1.78 },
"medisch-centrum-leeuwarden": { aspectRatio: 1.00 },
"medisys-health-network": { aspectRatio: 5.12 },
"meditech-greenfield": { aspectRatio: 2.29 },
"medplum-test": { aspectRatio: 1.00 },
"medplum": { aspectRatio: 2.72 },
"medstar-family-choice": { aspectRatio: 2.46 },
"medstar": { aspectRatio: 3.76 },
"memorial-health": { aspectRatio: 2.51 },
"memorial-healthcare-system": { aspectRatio: 2.51 },
"memorial-hermann-health-system": { aspectRatio: 2.00 },
"memorial-hospital-and-healthcare-center": { aspectRatio: 1.00 },
"memorial-regional-health": { aspectRatio: 1.00 },
"memorial-sloan-kettering-cancer-center": { aspectRatio: 4.74 },
"memorialcare": { aspectRatio: 2.33 },
"men-s-mental-health": { aspectRatio: 1.58 },
"mercer-health": { aspectRatio: 1.00 },
"mercy-care-plan": { aspectRatio: 1.00 },
"mercy-care": { aspectRatio: 1.51 },
"mercy-health-services": { aspectRatio: 1.27 },
"mercy-health": { aspectRatio: 2.72 },
"mercy-life-inc": { aspectRatio: 2.17 },
"mercy-medical-center": { aspectRatio: 1.91 },
"mercy": { aspectRatio: 1.00 },
"mercycare-health-plans": { aspectRatio: 1.00 },
"mercyone": { aspectRatio: 2.98 },
"meridian-health-plan-of-michigan": { aspectRatio: 3.66 },
"meridian-medicare-medicaid-plan": { aspectRatio: 3.66 },
"meridian": { aspectRatio: 1.73 },
"meridiancomplete-medicare-medicaid-plan": { aspectRatio: 1.51 },
"meritain-health": { aspectRatio: 1.80 },
"meritus": { aspectRatio: 1.00 },
"methodist-health-system": { aspectRatio: 3.88 },
"methodist-hospitals": { aspectRatio: 3.88 },
"methodist-le-bonheur-healthcare": { aspectRatio: 4.74 },
"metro-imaging": { aspectRatio: 1.78 },
"metrohealth-oh": { aspectRatio: 1.78 },
"metroplus-health-plan-dev": { aspectRatio: 3.46 },
"metroplus-health-plan-uat": { aspectRatio: 2.00 },
"metroplus-health-plan": { aspectRatio: 2.00 },
"mhs-health-wisconsin": { aspectRatio: 1.00 },
"mhs": { aspectRatio: 1.00 },
"miami-beach-community-health-center": { aspectRatio: 4.27 },
"michigan-department-of-health-and-human-services": { aspectRatio: 1.64 },
"michigan-medicine-umichigan": { aspectRatio: 1.58 },
"michigan-state-medicaid": { aspectRatio: 1.56 },
"middlesex-health": { aspectRatio: 3.28 },
"midwestern-university-clinics": { aspectRatio: 1.75 },
"mille-lacs-band-of-ojibwe": { aspectRatio: 0.92 },
"milwaukee-health-services": { aspectRatio: 2.98 },
"minidoka-memorial-hospital": { aspectRatio: 3.05 },
"minneapolis-clinic-of-neurology-mychart": { aspectRatio: 2.42 },
"minnesota-community-care": { aspectRatio: 0.63 },
"minsp": { aspectRatio: 1.91 },
"minute-clinic": { aspectRatio: 1.78 },
"mission-neighborhood-health-center": { aspectRatio: 1.00 },
"mississippi-pediatric-endocrine-care-pllc": { aspectRatio: 2.56 },
"mississippi-state-department-of-health": { aspectRatio: 1.00 },
"missoula-surgical-associates": { aspectRatio: 1.00 },
"missouri-medicare-select": { aspectRatio: 2.33 },
"missouri-state-medicaid-mo-healthnet": { aspectRatio: 2.91 },
"mitchell-family-medicine-and-the-ark-children-s-clinic": { aspectRatio: 1.00 },
"mitre": { aspectRatio: 2.42 },
"mo-healthnet-test": { aspectRatio: 2.91 },
"mo-healthnet": { aspectRatio: 2.91 },
"moda-health": { aspectRatio: 2.03 },
"mohawk-valley-health-system": { aspectRatio: 1.78 },
"molina-health": { aspectRatio: 2.37 },
"molina-healthcare": { aspectRatio: 2.37 },
"montage-health": { aspectRatio: 4.00 },
"montefiore-health-system-inc": { aspectRatio: 2.91 },
"monterey-county-health-department-clinic-services": { aspectRatio: 5.82 },
"monument-health": { aspectRatio: 1.29 },
"moonat-med-associates": { aspectRatio: 1.51 },
"morecare": { aspectRatio: 3.76 },
"morehouse-healthcare": { aspectRatio: 3.12 },
"mosaic-life-care": { aspectRatio: 1.00 },
"mosaic-medical": { aspectRatio: 2.00 },
"mount-auburn": { aspectRatio: 3.37 },
"mount-sinai-florida": { aspectRatio: 1.91 },
"mount-sinai-new-york-concierge-care": { aspectRatio: 1.00 },
"mountain-valleys-health-centers": { aspectRatio: 1.00 },
"mountain-west-surgical-specialists": { aspectRatio: 3.76 },
"mountainside-medical-center": { aspectRatio: 1.00 },
"mountsinai": { aspectRatio: 0.81 },
"mri-of-louisiana": { aspectRatio: 2.03 },
"mtosc": { aspectRatio: 1.80 },
"mts": { aspectRatio: 1.91 },
"multicare": { aspectRatio: 3.66 },
"multnomah-county-health-department": { aspectRatio: 1.00 },
"murray-county-medical-center": { aspectRatio: 1.78 },
"musc-health": { aspectRatio: 1.83 },
"muscogee-creek-nation": { aspectRatio: 1.00 },
"muslim-community-and-health-care": { aspectRatio: 1.08 },
"mutual-health-services": { aspectRatio: 5.12 },
"mvp-health-care": { aspectRatio: 1.00 },
"my-dr-now": { aspectRatio: 3.20 },
"my-premise-health": { aspectRatio: 2.46 },
"myconnect-health-portal": { aspectRatio: 1.00 },
"mymichigan-health": { aspectRatio: 5.57 },
"myrtue-medical-center": { aspectRatio: 3.88 },
"nascentia-health": { aspectRatio: 2.78 },
"national-jewish-health": { aspectRatio: 2.61 },
"nationwide-children-s-hospital": { aspectRatio: 2.56 },
"native-american-community-clinic": { aspectRatio: 1.00 },
"native-american-health-center": { aspectRatio: 3.56 },
"nch-healthcare-system": { aspectRatio: 1.94 },
"nebraska-state-medicaid": { aspectRatio: 1.78 },
"nebraska-total-care": { aspectRatio: 1.00 },
"nehalem-bay-health-center": { aspectRatio: 0.70 },
"neighborcare-health": { aspectRatio: 4.92 },
"neighborhealth": { aspectRatio: 1.83 },
"neighborhood-family-medicine": { aspectRatio: 1.33 },
"neighborhood-health-center": { aspectRatio: 1.00 },
"neighborhood-health-clinic": { aspectRatio: 1.91 },
"neighborhood-health-plan-of-rhode-island": { aspectRatio: 3.56 },
"neighborhood-health-plan": { aspectRatio: 3.56 },
"nemours-children-s-health": { aspectRatio: 4.13 },
"neomed-center": { aspectRatio: 1.00 },
"network-health": { aspectRatio: 2.72 },
"neuroscience-group": { aspectRatio: 1.21 },
"nevada-health-centers": { aspectRatio: 2.51 },
"nevada-medicaid": { aspectRatio: 1.00 },
"nevada-state-medicaid": { aspectRatio: 3.46 },
"new-bedford-community-health": { aspectRatio: 1.29 },
"new-hampshire-healthy-families": { aspectRatio: 2.98 },
"new-hanover-regional-medical-center": { aspectRatio: 1.00 },
"new-jersey-familycare-medicaid": { aspectRatio: 6.10 },
"new-jersey-health-information-network-njhin": { aspectRatio: 2.00 },
"new-jersey-health-information-network": { aspectRatio: 2.00 },
"new-jersey-medicaid": { aspectRatio: 1.58 },
"new-life-clinic": { aspectRatio: 1.00 },
"new-york-presbyterian": { aspectRatio: 1.00 },
"new-york-state-medicaid": { aspectRatio: 5.82 },
"newport-hospital-and-health-services": { aspectRatio: 1.00 },
"nextblue-north-dakota": { aspectRatio: 1.00 },
"nextgen-health": { aspectRatio: 1.33 },
"nippon-life-benefits": { aspectRatio: 1.00 },
"noah": { aspectRatio: 2.67 },
"noms": { aspectRatio: 2.98 },
"nor-lea-hospital-district": { aspectRatio: 1.00 },
"north-bend-medical-center": { aspectRatio: 2.25 },
"north-carolina-department-of-health-and-human-services": { aspectRatio: 1.51 },
"north-coast-family-medical-group": { aspectRatio: 2.21 },
"north-dakota-medicaid": { aspectRatio: 2.67 },
"north-dakota-state-medicaid": { aspectRatio: 2.67 },
"north-east-medical-services": { aspectRatio: 1.10 },
"north-lakes": { aspectRatio: 1.00 },
"north-memorial": { aspectRatio: 1.66 },
"north-mississippi-health-services": { aspectRatio: 5.12 },
"north-oaks-health-system": { aspectRatio: 3.20 },
"north-olympic-healthcare-network": { aspectRatio: 1.00 },
"north-shore-community-health": { aspectRatio: 4.00 },
"northeast-georgia-health-system": { aspectRatio: 7.53 },
"northwell-health-nuvance-blue": { aspectRatio: 1.47 },
"northwell-health-nuvance-green": { aspectRatio: 1.47 },
"northwell-health-nuvance": { aspectRatio: 1.47 },
"northwell-health": { aspectRatio: 1.83 },
"northwestern-medicine-legacy": { aspectRatio: 1.00 },
"northwestern-medicine": { aspectRatio: 5.12 },
"norton-healthcare": { aspectRatio: 4.00 },
"novant-health-partners": { aspectRatio: 2.17 },
"novant": { aspectRatio: 1.01 },
"nurture-women-s-care": { aspectRatio: 3.05 },
"nyc-health-and-hospitals": { aspectRatio: 2.03 },
"nyu-langone-health": { aspectRatio: 2.37 },
"nyu-langone": { aspectRatio: 1.91 },
"oakleaf-clinics-oakleaf-medical-network": { aspectRatio: 2.84 },
"ocean-beach-hospital-and-medical-center": { aspectRatio: 2.29 },
"ochin": { aspectRatio: 3.28 },
"ochsner-health-system": { aspectRatio: 1.91 },
"ohana-health-plan": { aspectRatio: 1.51 },
"ohio-department-of-mental-health-and-addiction-services": { aspectRatio: 3.66 },
"ohio-healthy": { aspectRatio: 2.46 },
"ohiohealth": { aspectRatio: 1.00 },
"oic-of-rocky-mount": { aspectRatio: 2.33 },
"oklahoma-complete-health": { aspectRatio: 1.91 },
"oklahoma-health-care-authority": { aspectRatio: 3.66 },
"oklahoma-heart-hospital": { aspectRatio: 2.67 },
"oklahoma-heart-institute": { aspectRatio: 1.00 },
"oklahoma-state-medicaid": { aspectRatio: 3.66 },
"oklahoma-state-university": { aspectRatio: 1.68 },
"olmsted-medical-center": { aspectRatio: 2.13 },
"olvg": { aspectRatio: 1.00 },
"olympic-medical-center": { aspectRatio: 3.76 },
"on-lok": { aspectRatio: 1.75 },
"one-brooklyn-health-system": { aspectRatio: 1.00 },
"one-community-health": { aspectRatio: 5.12 },
"onechart": { aspectRatio: 1.00 },
"onvida": { aspectRatio: 2.42 },
"open-epic": { aspectRatio: 2.00 },
"opendoor-community-health-center": { aspectRatio: 1.00 },
"optima-health": { aspectRatio: 3.12 },
"optimas-family-medicine": { aspectRatio: 3.46 },
"optimcurea-renal-and-vascular-access-care": { aspectRatio: 1.00 },
"optum-care-washington": { aspectRatio: 3.46 },
"optum-medical-care-of-inland-empire-and-san-diego": { aspectRatio: 3.46 },
"optum-medical-care-of-los-angeles-and-orange-county": { aspectRatio: 3.46 },
"optum-medical-care": { aspectRatio: 3.46 },
"optum-mountain-west": { aspectRatio: 3.46 },
"orange-blossom-family-health": { aspectRatio: 3.88 },
"orange-city-area-health-system": { aspectRatio: 3.12 },
"orange-county-neurosurgical-associates": { aspectRatio: 2.00 },
"orange-county-thoracic-and-cardiovascular-surgeons": { aspectRatio: 1.00 },
"oregon-health-and-science-university": { aspectRatio: 1.00 },
"oregon-heart-center": { aspectRatio: 2.78 },
"oregon-medical-group": { aspectRatio: 1.00 },
"oregon-state-medicaid": { aspectRatio: 3.05 },
"orlando-health": { aspectRatio: 1.80 },
"orthocarolina": { aspectRatio: 7.11 },
"orthopedic-associates-of-hartford": { aspectRatio: 4.00 },
"orthovirginia": { aspectRatio: 1.00 },
"ortonville-area-health-services": { aspectRatio: 1.00 },
"osage-nation-health-system": { aspectRatio: 3.28 },
"oscar-health": { aspectRatio: 4.41 },
"oscar": { aspectRatio: 4.41 },
"osceola-medical-center": { aspectRatio: 1.78 },
"osf-healthcare": { aspectRatio: 1.60 },
"osu": { aspectRatio: 1.00 },
"ou-health": { aspectRatio: 2.84 },
"our-lady-of-lourdes-health": { aspectRatio: 1.00 },
"our-lady-of-the-angels-health": { aspectRatio: 3.56 },
"our-lady-of-the-lake-children-s-hospital": { aspectRatio: 3.56 },
"our-lady-of-the-lake-health": { aspectRatio: 3.56 },
"our-lady-of-the-lake-lsu": { aspectRatio: 2.13 },
"outer-cape-health-services": { aspectRatio: 1.49 },
"outreach-community-health-centers": { aspectRatio: 1.17 },
"ovatient": { aspectRatio: 1.91 },
"over-the-moon-pediatrics": { aspectRatio: 4.41 },
"overlake": { aspectRatio: 2.25 },
"owensboro": { aspectRatio: 1.56 },
"oxford-care": { aspectRatio: 1.00 },
"oxford-neurology": { aspectRatio: 2.37 },
"pa-health-and-wellness": { aspectRatio: 1.51 },
"pace-kc-missouri": { aspectRatio: 1.00 },
"pacific-medical-center": { aspectRatio: 1.00 },
"pacific-university-oregon": { aspectRatio: 1.47 },
"pacificsource-health-plans": { aspectRatio: 3.46 },
"pacificsource": { aspectRatio: 3.46 },
"packard-health": { aspectRatio: 1.00 },
"palouse-specialty-physicians": { aspectRatio: 3.37 },
"paramount-insurance-company": { aspectRatio: 1.00 },
"paramount": { aspectRatio: 1.00 },
"parkland-community-health-plan": { aspectRatio: 3.46 },
"parkland": { aspectRatio: 3.66 },
"parkview-bryan-and-montpelier-hospitals": { aspectRatio: 1.00 },
"parkview-health": { aspectRatio: 1.33 },
"parkville-health-services": { aspectRatio: 1.45 },
"partners-health-management": { aspectRatio: 2.67 },
"partnership-community-health": { aspectRatio: 1.17 },
"partnership-health-center": { aspectRatio: 1.00 },
"partnership-healthplan-of-california": { aspectRatio: 0.63 },
"pascack-valley-medical-center": { aspectRatio: 1.00 },
"passport-health-plan": { aspectRatio: 4.41 },
"patrius": { aspectRatio: 3.88 },
"paulding-county-hospital": { aspectRatio: 1.15 },
"peacehealth": { aspectRatio: 1.24 },
"peach-state-health-plan": { aspectRatio: 1.00 },
"peak-health": { aspectRatio: 1.91 },
"pearland-family-wellness-clinic": { aspectRatio: 1.00 },
"pediatric-digestive-care": { aspectRatio: 1.00 },
"pediatric-physicians-organization-at-children-s": { aspectRatio: 5.57 },
"pediatrust": { aspectRatio: 1.00 },
"penn-medicine": { aspectRatio: 6.40 },
"pennington-biomedical": { aspectRatio: 5.12 },
"pennsylvania-state-medicaid": { aspectRatio: 1.24 },
"people-s-community-clinic": { aspectRatio: 2.98 },
"peoples-community-health-clinic": { aspectRatio: 2.98 },
"peoples-health": { aspectRatio: 3.37 },
"perham-health": { aspectRatio: 1.58 },
"perlman-clinic": { aspectRatio: 5.82 },
"petaluma-health-center": { aspectRatio: 1.78 },
"phelps-health": { aspectRatio: 4.41 },
"php-northern-indiana": { aspectRatio: 1.00 },
"physicians-alliance-of-connecticut": { aspectRatio: 4.57 },
"physicians-health-plan": { aspectRatio: 2.98 },
"piedmont-healthcare": { aspectRatio: 1.00 },
"pikeville-medical-center": { aspectRatio: 2.51 },
"pine-rest": { aspectRatio: 1.78 },
"pine-springs-health": { aspectRatio: 1.00 },
"pines-health-services": { aspectRatio: 2.13 },
"pinnacle-primary-care": { aspectRatio: 1.23 },
"pioneer-memorial-hospital": { aspectRatio: 0.99 },
"plan-de-salud-menonita": { aspectRatio: 3.46 },
"planned-parenthood-of-northern-california": { aspectRatio: 2.25 },
"planned-parenthood": { aspectRatio: 3.12 },
"pocano-ambulatory-surgery-center": { aspectRatio: 1.78 },
"point32health": { aspectRatio: 6.10 },
"portneuf-medical-center": { aspectRatio: 1.00 },
"positive-healthcare": { aspectRatio: 2.51 },
"powers-health": { aspectRatio: 1.83 },
"pozitiv-wellness": { aspectRatio: 1.00 },
"prairie-cardiovascular": { aspectRatio: 4.00 },
"premera-blue-cross-individual": { aspectRatio: 4.13 },
"premera-blue-cross": { aspectRatio: 4.13 },
"premera-bluecross-individual": { aspectRatio: 4.13 },
"premera-bluecross": { aspectRatio: 4.13 },
"premier-community-healthcare": { aspectRatio: 1.00 },
"premier-health": { aspectRatio: 1.80 },
"premise-health": { aspectRatio: 2.46 },
"presbyterian-health-plan": { aspectRatio: 8.53 },
"presbyterian-healthcare-services": { aspectRatio: 8.53 },
"prestige-medical-sai": { aspectRatio: 1.24 },
"prevea-health": { aspectRatio: 2.29 },
"prevea360-p360": { aspectRatio: 2.78 },
"primary-health-care": { aspectRatio: 3.05 },
"prime-health-plus": { aspectRatio: 1.91 },
"prime-healthcare": { aspectRatio: 5.57 },
"primewest-health": { aspectRatio: 1.60 },
"primewest": { aspectRatio: 1.60 },
"prince-george-s-county-health-department": { aspectRatio: 1.00 },
"priority-health": { aspectRatio: 5.82 },
"priority-partners": { aspectRatio: 3.56 },
"prisma-health": { aspectRatio: 2.67 },
"progressive-community-health-centers": { aspectRatio: 5.12 },
"prohealth-care": { aspectRatio: 5.82 },
"prohealth-physicians": { aspectRatio: 1.60 },
"proliance-hand-wrist-and-elbow-physicians": { aspectRatio: 4.00 },
"proliance-orthopedics-and-sports-medicine": { aspectRatio: 2.91 },
"promedica": { aspectRatio: 5.12 },
"proortho-orthopedics-and-sports-medicine": { aspectRatio: 3.05 },
"prosser-memorial-health": { aspectRatio: 1.91 },
"providence-cedars-sinai-tarzana": { aspectRatio: 1.00 },
"providence-community-health-centers": { aspectRatio: 1.00 },
"providence-health-and-services": { aspectRatio: 1.00 },
"providence-health-plan": { aspectRatio: 3.56 },
"providence-swedish-rehabilitation-hospital": { aspectRatio: 1.00 },
"provider-partners-health-plan": { aspectRatio: 1.29 },
"public-health-management-corporation": { aspectRatio: 1.80 },
"puget-sound-orthopaedics": { aspectRatio: 1.00 },
"pullman-regional-hospital": { aspectRatio: 2.84 },
"quadmed": { aspectRatio: 1.78 },
"qualchoice": { aspectRatio: 1.00 },
"quality-of-life-health-services": { aspectRatio: 1.73 },
"quartz-health-solutions": { aspectRatio: 1.00 },
"quartz": { aspectRatio: 2.98 },
"queen-s-connect": { aspectRatio: 1.33 },
"quest-behavioral-health": { aspectRatio: 2.42 },
"radboudumc": { aspectRatio: 3.12 },
"radiant-health-centers": { aspectRatio: 1.00 },
"rady-children-s": { aspectRatio: 1.58 },
"rainy-lake-medical-center": { aspectRatio: 1.00 },
"rancho-family-medical-group": { aspectRatio: 3.46 },
"ravenswood-family-health-network": { aspectRatio: 1.00 },
"ray-county-hospital-and-healthcare": { aspectRatio: 3.46 },
"rc-hospitals-and-clinics": { aspectRatio: 1.00 },
"rebound-orthopedic-and-neurosurgery": { aspectRatio: 4.13 },
"redwoods-rural-health-center": { aspectRatio: 1.80 },
"regence-blue-shield": { aspectRatio: 1.20 },
"regence-bluecross-blueshield-of-oregon": { aspectRatio: 1.20 },
"regence-bluecross-blueshield-of-utah": { aspectRatio: 1.54 },
"regence-blueshield-of-idaho": { aspectRatio: 1.00 },
"regence-blueshield": { aspectRatio: 4.27 },
"reid-health": { aspectRatio: 4.92 },
"reliance-medicare-advantage": { aspectRatio: 1.33 },
"reliant-medical-group": { aspectRatio: 1.54 },
"renaissance": { aspectRatio: 1.64 },
"reno-orthopedic-center": { aspectRatio: 1.00 },
"renown": { aspectRatio: 3.20 },
"rhode-island-medicaid": { aspectRatio: 1.00 },
"rhode-island-state-medicaid": { aspectRatio: 1.05 },
"rice-memorial-hospital": { aspectRatio: 1.75 },
"richfield-medical-group": { aspectRatio: 1.00 },
"ridgeview": { aspectRatio: 3.37 },
"ritual-medical": { aspectRatio: 1.80 },
"river-hills-community-health-center": { aspectRatio: 1.88 },
"river-people-health-center": { aspectRatio: 1.00 },
"river-s-edge-hospital-and-clinic": { aspectRatio: 2.98 },
"river-valley-primary-care-services": { aspectRatio: 1.00 },
"riverbend-medical-group": { aspectRatio: 1.00 },
"riverland-community-health": { aspectRatio: 1.00 },
"riverside-health-system": { aspectRatio: 3.66 },
"riverside-medical-center": { aspectRatio: 2.21 },
"riverside-medical-clinic": { aspectRatio: 1.17 },
"riverside-university-health-system": { aspectRatio: 2.72 },
"riverspring-health-plans": { aspectRatio: 9.85 },
"riverspring-health": { aspectRatio: 9.85 },
"riverview-health": { aspectRatio: 1.62 },
"riverwood-healthcare-center": { aspectRatio: 1.66 },
"rmh": { aspectRatio: 1.24 },
"robeson-health-care": { aspectRatio: 2.51 },
"rochelle-community-hospital": { aspectRatio: 1.00 },
"rochester-general": { aspectRatio: 2.25 },
"rocky-mountain-ent": { aspectRatio: 1.44 },
"rocky-mountain-health-plans": { aspectRatio: 1.00 },
"rogue-community-health": { aspectRatio: 3.66 },
"root-center-for-advanced-recovery": { aspectRatio: 3.12 },
"roper-st-francis": { aspectRatio: 1.22 },
"royal-devon-university-healthcare": { aspectRatio: 2.25 },
"rukmini-d-kumar-md": { aspectRatio: 1.78 },
"rush-university-medical-center": { aspectRatio: 1.91 },
"rutgers-health-university-behavioral-health-care": { aspectRatio: 4.13 },
"rwjbarnabas-health": { aspectRatio: 1.68 },
"saban": { aspectRatio: 1.00 },
"sac-health-system": { aspectRatio: 5.57 },
"sacramento-county-public-health": { aspectRatio: 1.66 },
"safhir": { aspectRatio: 1.00 },
"saint-francis-health-system": { aspectRatio: 1.00 },
"saint-francis-healthcare-system": { aspectRatio: 1.73 },
"saint-james-health": { aspectRatio: 2.00 },
"saint-luke-s-health-system": { aspectRatio: 4.41 },
"salem-clinic": { aspectRatio: 1.00 },
"salem-health": { aspectRatio: 1.00 },
"salem-township-hospital": { aspectRatio: 3.28 },
"salinas-valley-health-affiliates": { aspectRatio: 4.57 },
"salinas-valley-health": { aspectRatio: 4.57 },
"samaritan-health-plans-test": { aspectRatio: 2.61 },
"samaritan-health-plans": { aspectRatio: 2.61 },
"samaritan-health-services": { aspectRatio: 3.56 },
"samaritan-healthcare": { aspectRatio: 2.78 },
"samba": { aspectRatio: 2.13 },
"san-diego-ear-nose-and-throat-specialists-mychart": { aspectRatio: 2.56 },
"san-diego-sports-medicine": { aspectRatio: 3.56 },
"san-francisco-community-clinic-consortium": { aspectRatio: 2.46 },
"san-francisco-community-health-center": { aspectRatio: 1.00 },
"san-francisco-dept-of-public-health": { aspectRatio: 2.42 },
"san-francisco-health-plan-sfhp": { aspectRatio: 1.00 },
"san-francisco-health-plan": { aspectRatio: 1.00 },
"san-ysidro-health": { aspectRatio: 1.00 },
"sanford-health-group": { aspectRatio: 2.21 },
"sanford-health-plan": { aspectRatio: 2.25 },
"sanford-health": { aspectRatio: 2.21 },
"sanford": { aspectRatio: 1.00 },
"sansum": { aspectRatio: 1.00 },
"santa-clara-family-health-plan": { aspectRatio: 3.88 },
"santa-clara": { aspectRatio: 1.68 },
"santa-cruz-community-health": { aspectRatio: 1.00 },
"santa-fe-imaging": { aspectRatio: 1.00 },
"santa-lucia-medical-group": { aspectRatio: 1.00 },
"santa-rosa-community-health": { aspectRatio: 2.29 },
"santiam-hospital": { aspectRatio: 1.00 },
"scan-health-plan": { aspectRatio: 1.91 },
"scheurer": { aspectRatio: 1.00 },
"school-health-clinics-of-santa-clara-county": { aspectRatio: 0.83 },
"scotland-health-care-system": { aspectRatio: 1.73 },
"scripps-health": { aspectRatio: 4.13 },
"sea-mar": { aspectRatio: 1.00 },
"seattle-children-s-mychart": { aspectRatio: 1.00 },
"seattle-indian-health-board": { aspectRatio: 0.48 },
"seattle-medical-associates": { aspectRatio: 1.00 },
"seattle-premier-health": { aspectRatio: 1.36 },
"seattle-roots-community-health": { aspectRatio: 2.78 },
"security-health-plan-of-wisconsin": { aspectRatio: 1.60 },
"security-health-plan": { aspectRatio: 1.60 },
"seen-health-pace": { aspectRatio: 2.17 },
"select-health-of-south-carolina": { aspectRatio: 1.00 },
"select-health": { aspectRatio: 2.33 },
"select-medical": { aspectRatio: 1.62 },
"selecthealth": { aspectRatio: 2.33 },
"self-regional": { aspectRatio: 3.12 },
"sendero-health": { aspectRatio: 2.78 },
"senior-whole-health": { aspectRatio: 2.29 },
"sentara-health-plans": { aspectRatio: 3.46 },
"sentara-health": { aspectRatio: 3.46 },
"sentara-healthcare": { aspectRatio: 1.78 },
"seton-medical-center-and-wellstone-health-partners": { aspectRatio: 1.33 },
"seward-community-health-center": { aspectRatio: 1.78 },
"sgmc": { aspectRatio: 2.46 },
"shannon": { aspectRatio: 1.00 },
"share-our-selves": { aspectRatio: 1.00 },
"sharp-health-plan": { aspectRatio: 1.00 },
"shepherd-center": { aspectRatio: 0.84 },
"shepherd-s-hope": { aspectRatio: 1.54 },
"shodair-children-s-hospital": { aspectRatio: 1.73 },
"shriner-s-childrens": { aspectRatio: 0.88 },
"sick-kids-cheo": { aspectRatio: 2.98 },
"sidney-health-center": { aspectRatio: 1.78 },
"sierra-health-and-life": { aspectRatio: 3.05 },
"signature-advantage": { aspectRatio: 2.56 },
"signature-health": { aspectRatio: 1.00 },
"sih-affiliates": { aspectRatio: 1.66 },
"siho": { aspectRatio: 5.82 },
"silversummit-healthplan": { aspectRatio: 1.66 },
"simplepay-health": { aspectRatio: 1.78 },
"simply-healthcare-medicaid": { aspectRatio: 2.37 },
"simply-healthcare-medicare": { aspectRatio: 2.98 },
"simply-healthcare": { aspectRatio: 2.98 },
"simpra-advantage": { aspectRatio: 3.46 },
"sinai-chicago": { aspectRatio: 3.88 },
"singing-river-health-system": { aspectRatio: 6.10 },
"sint-antonius-ziekenhuis": { aspectRatio: 3.05 },
"siouxland-community-health-center": { aspectRatio: 3.28 },
"sisco": { aspectRatio: 1.00 },
"sixteenth-street": { aspectRatio: 1.00 },
"skagit": { aspectRatio: 4.41 },
"sky-lakes": { aspectRatio: 5.12 },
"slucare": { aspectRatio: 2.61 },
"smile-generation-mychart": { aspectRatio: 1.00 },
"snoqualmie-valley-health": { aspectRatio: 2.51 },
"sohum-health": { aspectRatio: 3.56 },
"solano-county": { aspectRatio: 2.25 },
"solutionhealth": { aspectRatio: 2.00 },
"sonoma-county-indian-health-project": { aspectRatio: 4.57 },
"sonoma-valley-community-health-center": { aspectRatio: 3.66 },
"sonoma-valley-hospital": { aspectRatio: 1.88 },
"south-boston-community-health-center": { aspectRatio: 1.00 },
"south-country-health-alliance": { aspectRatio: 1.66 },
"south-dakota-state-medicaid": { aspectRatio: 1.44 },
"south-of-market-health-center": { aspectRatio: 1.00 },
"south-peninsula-hospital": { aspectRatio: 1.80 },
"south-shore-health": { aspectRatio: 1.00 },
"south-tabor-family-physicians-and-services": { aspectRatio: 2.37 },
"southcoast-health-system": { aspectRatio: 4.00 },
"southeast-health": { aspectRatio: 3.05 },
"southeastern-indiana-health-organization": { aspectRatio: 1.00 },
"southern-california-multi-specialty-center": { aspectRatio: 1.07 },
"southern-coos-hospital-and-health-center": { aspectRatio: 3.46 },
"southern-illinois-healthcare": { aspectRatio: 0.93 },
"southern-jersey-family-medical-centers": { aspectRatio: 1.73 },
"southern-oregon-orthopedics": { aspectRatio: 2.78 },
"southside-health-center": { aspectRatio: 1.00 },
"southwest-community-health-center": { aspectRatio: 1.00 },
"southwest-medical": { aspectRatio: 2.98 },
"southwest-mississippi-regional-medical-center": { aspectRatio: 4.41 },
"spaarne-gasthuis": { aspectRatio: 1.00 },
"spartanburg-regional-healthcare-system": { aspectRatio: 1.78 },
"specialty-physicians-of-illinois": { aspectRatio: 3.88 },
"spooner-health": { aspectRatio: 1.00 },
"spry-health": { aspectRatio: 1.00 },
"sprysenior": { aspectRatio: 1.51 },
"ssandc-health-edifecs": { aspectRatio: 4.00 },
"ssm-health": { aspectRatio: 1.00 },
"st-anthony-s": { aspectRatio: 2.06 },
"st-barnabas-health": { aspectRatio: 1.00 },
"st-charles-health-system": { aspectRatio: 2.56 },
"st-croix-health": { aspectRatio: 1.00 },
"st-david-s": { aspectRatio: 1.78 },
"st-dominic-s": { aspectRatio: 1.78 },
"st-elizabeth-healthcare": { aspectRatio: 3.56 },
"st-francis-health": { aspectRatio: 1.00 },
"st-gabriel-s-health": { aspectRatio: 1.19 },
"st-jansdal-ziekenhuis": { aspectRatio: 1.00 },
"st-joseph-s-healthcare-hamilton": { aspectRatio: 1.88 },
"st-joseph-s-hospital-health-center": { aspectRatio: 2.51 },
"st-jude": { aspectRatio: 2.51 },
"st-luke-s-health-plan": { aspectRatio: 1.97 },
"st-luke-s-hospital": { aspectRatio: 2.51 },
"st-luke-s": { aspectRatio: 2.51 },
"st-peter-s-health": { aspectRatio: 3.66 },
"st-tammany": { aspectRatio: 2.51 },
"st-thomas-community-health-center": { aspectRatio: 1.00 },
"stamford-health": { aspectRatio: 1.00 },
"stanford-children-s-health": { aspectRatio: 1.00 },
"stanford": { aspectRatio: 2.00 },
"star-valley-health": { aspectRatio: 1.24 },
"starling": { aspectRatio: 2.91 },
"state-of-alabama-medicaid": { aspectRatio: 1.05 },
"state-of-alabama-stage": { aspectRatio: 1.71 },
"state-of-alabama-test": { aspectRatio: 2.29 },
"state-of-alabama": { aspectRatio: 1.78 },
"state-of-alaska-medicaid": { aspectRatio: 1.00 },
"state-of-alaska": { aspectRatio: 1.00 },
"state-of-arkansas-medicaid": { aspectRatio: 3.20 },
"state-of-arkansas": { aspectRatio: 1.00 },
"state-of-colorado-medicaid": { aspectRatio: 6.10 },
"state-of-colorado": { aspectRatio: 1.28 },
"state-of-connecticut-medicaid": { aspectRatio: 1.02 },
"state-of-connecticut": { aspectRatio: 1.02 },
"state-of-delaware-medicaid": { aspectRatio: 1.00 },
"state-of-delaware": { aspectRatio: 1.00 },
"state-of-georgia-medicaid": { aspectRatio: 2.10 },
"state-of-georgia": { aspectRatio: 3.46 },
"state-of-hawaii": { aspectRatio: 1.00 },
"state-of-idaho-medicaid": { aspectRatio: 1.00 },
"state-of-idaho": { aspectRatio: 1.00 },
"state-of-iowa-medicaid": { aspectRatio: 1.00 },
"state-of-iowa": { aspectRatio: 1.51 },
"state-of-kansas-medicaid": { aspectRatio: 3.37 },
"state-of-kansas": { aspectRatio: 1.00 },
"state-of-kentucky-medicaid": { aspectRatio: 1.00 },
"state-of-kentucky": { aspectRatio: 1.12 },
"state-of-louisiana-medicaid": { aspectRatio: 1.91 },
"state-of-louisiana": { aspectRatio: 1.68 },
"state-of-maine-medicaid": { aspectRatio: 3.28 },
"state-of-maine": { aspectRatio: 1.00 },
"state-of-maryland-medicaid": { aspectRatio: 1.78 },
"state-of-maryland": { aspectRatio: 1.80 },
"state-of-michigan-medicaid": { aspectRatio: 1.56 },
"state-of-michigan": { aspectRatio: 2.42 },
"state-of-missouri-medicaid": { aspectRatio: 1.51 },
"state-of-missouri": { aspectRatio: 2.51 },
"state-of-nebraska": { aspectRatio: 3.28 },
"state-of-nevada-medicaid": { aspectRatio: 3.46 },
"state-of-nevada": { aspectRatio: 1.00 },
"state-of-new-jersey-medicaid": { aspectRatio: 0.80 },
"state-of-new-jersey": { aspectRatio: 3.20 },
"state-of-new-york": { aspectRatio: 1.00 },
"state-of-north-dakota-medicaid": { aspectRatio: 2.67 },
"state-of-north-dakota": { aspectRatio: 2.67 },
"state-of-ohio-medicaid": { aspectRatio: 3.66 },
"state-of-oklahoma-medicaid": { aspectRatio: 3.66 },
"state-of-oklahoma": { aspectRatio: 2.84 },
"state-of-oregon": { aspectRatio: 3.05 },
"state-of-pennsylvania-medicaid": { aspectRatio: 2.91 },
"state-of-pennsylvania": { aspectRatio: 2.98 },
"state-of-rhode-island-medicaid": { aspectRatio: 1.05 },
"state-of-rhode-island": { aspectRatio: 1.00 },
"state-of-south-dakota": { aspectRatio: 1.83 },
"state-of-tennessee-medicaid": { aspectRatio: 1.00 },
"state-of-tennessee": { aspectRatio: 2.42 },
"state-of-utah-medicaid": { aspectRatio: 2.56 },
"state-of-utah": { aspectRatio: 1.51 },
"state-of-vermont-medicaid": { aspectRatio: 1.58 },
"state-of-vermont": { aspectRatio: 1.00 },
"state-of-washington-medicaid": { aspectRatio: 5.57 },
"state-of-washington": { aspectRatio: 2.33 },
"state-of-west-virginia-medicaid": { aspectRatio: 2.42 },
"state-of-west-virginia": { aspectRatio: 2.84 },
"state-of-wisconsin-medicaid": { aspectRatio: 3.76 },
"state-of-wisconsin": { aspectRatio: 1.00 },
"state-of-wyoming-medicaid": { aspectRatio: 0.84 },
"state-of-wyoming-stage": { aspectRatio: 0.70 },
"state-of-wyoming": { aspectRatio: 0.88 },
"steindler-orthopedic-clinic": { aspectRatio: 1.54 },
"stellis-health": { aspectRatio: 3.37 },
"stevens-community-medical-center": { aspectRatio: 4.00 },
"steward-health-choice": { aspectRatio: 1.00 },
"stigler-health-and-wellness-center": { aspectRatio: 1.00 },
"stillaguamish-tribe-of-indians": { aspectRatio: 2.00 },
"stormont-vail-health-care": { aspectRatio: 1.00 },
"sublette-county-health": { aspectRatio: 4.27 },
"sublette-prior-to-8425": { aspectRatio: 1.88 },
"sugar-land-pain-and-spine-specialists": { aspectRatio: 1.78 },
"summa-health": { aspectRatio: 1.73 },
"summacare": { aspectRatio: 1.00 },
"summit-community-care": { aspectRatio: 2.78 },
"summit-county-public-health": { aspectRatio: 1.02 },
"summit-health-citymd": { aspectRatio: 1.51 },
"summit-health-oregon": { aspectRatio: 1.86 },
"summit-health": { aspectRatio: 1.54 },
"summit-pacific-medical-center": { aspectRatio: 1.00 },
"summit-surgical-center": { aspectRatio: 1.10 },
"sun-life": { aspectRatio: 4.13 },
"sunflower-health-plan": { aspectRatio: 0.63 },
"sunshine-health": { aspectRatio: 1.00 },
"suny": { aspectRatio: 1.29 },
"superior-healthplan": { aspectRatio: 1.80 },
"surgical-clinic-associates": { aspectRatio: 1.00 },
"susquehanna-valley-medical-specialties": { aspectRatio: 1.00 },
"sutter-health-plus": { aspectRatio: 5.57 },
"sutter-health": { aspectRatio: 4.41 },
"swedish": { aspectRatio: 1.00 },
"swedishamerican": { aspectRatio: 1.00 },
"syracuse-community-health": { aspectRatio: 1.00 },
"tahoe-forest-health-system": { aspectRatio: 2.29 },
"tall-tree-administrators": { aspectRatio: 1.00 },
"tallahassee-memorial-healthcare": { aspectRatio: 1.27 },
"tampa-family-health-centers": { aspectRatio: 1.00 },
"tampa-general-hospital": { aspectRatio: 3.37 },
"tanner-health-system": { aspectRatio: 4.74 },
"tarzana-treatment-center": { aspectRatio: 0.99 },
"templehealth": { aspectRatio: 8.53 },
"terrebonne-general-medical-center": { aspectRatio: 4.57 },
"terry-reilly-health-services": { aspectRatio: 1.91 },
"texas-aandm-health": { aspectRatio: 1.16 },
"texas-children-s": { aspectRatio: 1.47 },
"texas-family-clinic": { aspectRatio: 1.22 },
"texas-health-resources": { aspectRatio: 4.74 },
"texas-independence-health-plan": { aspectRatio: 3.12 },
"texas-scottish-rite-hospital-for-children": { aspectRatio: 2.61 },
"the-baton-rouge-clinic": { aspectRatio: 1.00 },
"the-center": { aspectRatio: 2.33 },
"the-centers": { aspectRatio: 2.33 },
"the-christ-hospital": { aspectRatio: 3.05 },
"the-health-center-at-hudson-yards": { aspectRatio: 1.00 },
"the-health-plan-of-west-virginia": { aspectRatio: 3.37 },
"the-health-plan": { aspectRatio: 3.37 },
"the-institute-for-family-health": { aspectRatio: 1.91 },
"the-kempton-group": { aspectRatio: 5.12 },
"the-native-project": { aspectRatio: 3.20 },
"the-nebraska-medical-center": { aspectRatio: 1.29 },
"the-neurology-center": { aspectRatio: 2.06 },
"the-oregon-clinic": { aspectRatio: 2.67 },
"the-ottawa-hospital": { aspectRatio: 1.01 },
"the-pediatric-center-boulder": { aspectRatio: 1.80 },
"the-portland-clinic": { aspectRatio: 2.67 },
"the-queen-s-health-system": { aspectRatio: 1.33 },
"the-royal-childrens-hospital": { aspectRatio: 1.00 },
"the-university-of-kansas-health-system": { aspectRatio: 4.41 },
"thedacare": { aspectRatio: 2.00 },
"thomas-jefferson-university-health-system": { aspectRatio: 1.91 },
"thunder-basin": { aspectRatio: 1.00 },
"tiburcio-vasquez-health-center": { aspectRatio: 1.29 },
"tidalhealth": { aspectRatio: 1.91 },
"tidelands-health": { aspectRatio: 1.27 },
"tillamook-county-community-health-centers": { aspectRatio: 1.00 },
"titus-regional-medical-center": { aspectRatio: 2.67 },
"tomah-health-april-1-2022-and-after": { aspectRatio: 2.33 },
"torrey-pines-orthopaedics-and-sports-medicine": { aspectRatio: 1.00 },
"tower-health": { aspectRatio: 2.56 },
"treasure-coast-community-health": { aspectRatio: 2.10 },
"triad-adult-and-pediatric-medicine": { aspectRatio: 1.75 },
"tribute-health-plans": { aspectRatio: 1.00 },
"tricare": { aspectRatio: 2.00 },
"trihealth": { aspectRatio: 4.00 },
"trillium-community-health-plan": { aspectRatio: 1.51 },
"trillium-health-partners": { aspectRatio: 2.17 },
"trillium-health-resources": { aspectRatio: 3.05 },
"trinity-health-of-new-england": { aspectRatio: 1.33 },
"trinity-health-pace-of-alexandria": { aspectRatio: 5.33 },
"trinity-health-pace-of-pensacola": { aspectRatio: 2.17 },
"trinity-health": { aspectRatio: 3.46 },
"triple-s": { aspectRatio: 6.10 },
"true-health": { aspectRatio: 1.20 },
"truecare": { aspectRatio: 4.57 },
"trustmark": { aspectRatio: 1.78 },
"tuality-healthcare": { aspectRatio: 4.00 },
"tucson-independent-physicians-and-surgeons": { aspectRatio: 2.61 },
"tucson-medical-center": { aspectRatio: 3.12 },
"tufts-health-plan": { aspectRatio: 1.91 },
"tufts-health-public-plans-thpp": { aspectRatio: 1.91 },
"tufts-medicine": { aspectRatio: 2.00 },
"tufts-senior-plan-medicare": { aspectRatio: 1.91 },
"tulalip-health-system": { aspectRatio: 1.28 },
"tulsa-bone-and-joint-associates": { aspectRatio: 2.42 },
"tulsa-spine-and-specialty-hospital": { aspectRatio: 2.00 },
"uc-davis": { aspectRatio: 2.84 },
"uc-health": { aspectRatio: 2.78 },
"uc-san-diego-employee-sso": { aspectRatio: 1.51 },
"uc-san-diego-student-health": { aspectRatio: 3.46 },
"uc-san-diego": { aspectRatio: 1.73 },
"ucare": { aspectRatio: 5.82 },
"uchealth-affiliated-clinics-and-hospitals-mychart": { aspectRatio: 6.40 },
"uchealth": { aspectRatio: 4.57 },
"uci-health": { aspectRatio: 2.67 },
"ucla-health-medicare-advantage-plan": { aspectRatio: 7.11 },
"ucla-medical-center": { aspectRatio: 1.33 },
"uconn-health": { aspectRatio: 1.51 },
"ucr-health": { aspectRatio: 1.00 },
"ucsf-health": { aspectRatio: 1.00 },
"ucsf": { aspectRatio: 1.00 },
"uha-health-insurance": { aspectRatio: 1.00 },
"uhi": { aspectRatio: 1.00 },
"ui-health": { aspectRatio: 1.41 },
"uihc": { aspectRatio: 1.68 },
"uk-healthcare": { aspectRatio: 1.80 },
"uk-king-s-daughters": { aspectRatio: 1.80 },
"umass-memorial-health": { aspectRatio: 1.94 },
"umc-southern-nevada": { aspectRatio: 3.46 },
"umcg": { aspectRatio: 5.33 },
"umpqua-health-alliance": { aspectRatio: 1.78 },
"umr": { aspectRatio: 1.80 },
"unc-health-care": { aspectRatio: 1.78 },
"und-center-for-family-medicine": { aspectRatio: 1.94 },
"unicare-massachusetts": { aspectRatio: 1.00 },
"unicare-medicaid": { aspectRatio: 1.97 },
"unicare": { aspectRatio: 1.00 },
"united-ag": { aspectRatio: 0.97 },
"united-community-and-family-services-healthcare": { aspectRatio: 6.74 },
"united-community-health-center": { aspectRatio: 1.97 },
"united-concordia-dental": { aspectRatio: 4.74 },
"united-health-services": { aspectRatio: 1.97 },
"united-healthcare-all-savers": { aspectRatio: 3.20 },
"united-healthcare": { aspectRatio: 1.88 },
"united-hospital-district": { aspectRatio: 1.73 },
"united-regional": { aspectRatio: 2.21 },
"unitedhealthcare": { aspectRatio: 1.88 },
"unity-care-nw": { aspectRatio: 3.66 },
"unity-health-toronto": { aspectRatio: 1.91 },
"unitypoint-health": { aspectRatio: 5.33 },
"univera-healthcare": { aspectRatio: 3.05 },
"univera": { aspectRatio: 3.05 },
"university-clinical-health": { aspectRatio: 1.00 },
"university-college-london-hospitals": { aspectRatio: 1.05 },
"university-health-network": { aspectRatio: 1.00 },
"university-health-system": { aspectRatio: 1.51 },
"university-health": { aspectRatio: 1.51 },
"university-hospital": { aspectRatio: 1.91 },
"university-hospitals-cleveland": { aspectRatio: 2.25 },
"university-of-arkansas-for-medical-sciences": { aspectRatio: 2.84 },
"university-of-chicago-hospitals": { aspectRatio: 2.00 },
"university-of-florida": { aspectRatio: 2.46 },
"university-of-kansas-health-system": { aspectRatio: 4.41 },
"university-of-louisville-physicians": { aspectRatio: 1.00 },
"university-of-maryland-medical-system": { aspectRatio: 3.76 },
"university-of-miami": { aspectRatio: 1.91 },
"university-of-michigan-health-plan": { aspectRatio: 1.91 },
"university-of-michigan-health-sparrow": { aspectRatio: 1.66 },
"university-of-michigan-health-west": { aspectRatio: 1.54 },
"university-of-michigan-health": { aspectRatio: 1.68 },
"university-of-minnesota-physicians": { aspectRatio: 1.00 },
"university-of-minnesota": { aspectRatio: 1.88 },
"university-of-mississippi-medical-center": { aspectRatio: 3.76 },
"university-of-rochester": { aspectRatio: 1.80 },
"university-of-south-florida": { aspectRatio: 1.00 },
"university-of-texas-md-anderson-cancer-center": { aspectRatio: 1.97 },
"university-of-toledo": { aspectRatio: 2.72 },
"university-of-utah-health-plans": { aspectRatio: 3.76 },
"university-of-utah": { aspectRatio: 1.44 },
"university-of-vermont-health-network": { aspectRatio: 5.82 },
"university-of-virginia": { aspectRatio: 2.78 },
"unlv-health": { aspectRatio: 1.91 },
"unum-always-assist": { aspectRatio: 3.12 },
"unum-dental": { aspectRatio: 3.12 },
"upmc-health-plan": { aspectRatio: 1.91 },
"upmc-health-system": { aspectRatio: 2.91 },
"upmc-health": { aspectRatio: 2.91 },
"upmc-in-central-pa": { aspectRatio: 1.00 },
"upmc-patient-portal": { aspectRatio: 1.33 },
"upmc-western-pennsylvania": { aspectRatio: 3.56 },
"upmc": { aspectRatio: 2.91 },
"upper-peninsula-health-plan-uphp": { aspectRatio: 3.76 },
"upper-peninsula-health-plan": { aspectRatio: 3.76 },
"uptown-community-health-center": { aspectRatio: 3.66 },
"upwell-primary-care": { aspectRatio: 1.00 },
"urgent-care-lakelourdesst-francis": { aspectRatio: 1.00 },
"ut-health-east-texas": { aspectRatio: 1.00 },
"ut-medicine-san-antonio": { aspectRatio: 1.22 },
"utah-medicaid": { aspectRatio: 2.61 },
"utah-state-medicaid": { aspectRatio: 5.57 },
"uthealth-houston": { aspectRatio: 2.29 },
"utica-park-clinic": { aspectRatio: 6.10 },
"utmb": { aspectRatio: 2.51 },
"utsw": { aspectRatio: 2.91 },
"uw-health": { aspectRatio: 1.91 },
"uw-medicine": { aspectRatio: 1.49 },
"valley-children-s-hospital": { aspectRatio: 2.46 },
"valley-family-health-care": { aspectRatio: 1.91 },
"valley-health-partners": { aspectRatio: 3.20 },
"valley-health-plan": { aspectRatio: 1.00 },
"valley-health-system": { aspectRatio: 2.13 },
"valley-health": { aspectRatio: 2.13 },
"valley-medical-center": { aspectRatio: 4.74 },
"valleywise": { aspectRatio: 1.00 },
"van-buren-county-hospital": { aspectRatio: 4.41 },
"vancouver-clinic": { aspectRatio: 4.00 },
"vanderbilt-university-medical-center": { aspectRatio: 5.82 },
"vantage-health-plan": { aspectRatio: 2.56 },
"variety-care-health-centers": { aspectRatio: 1.00 },
"vaya-health": { aspectRatio: 1.00 },
"vcu-health": { aspectRatio: 3.20 },
"vecino-health-centers": { aspectRatio: 1.56 },
"venice-family-clinic": { aspectRatio: 4.92 },
"veradigm-allscripts": { aspectRatio: 4.57 },
"vermont-medicaid": { aspectRatio: 3.28 },
"vermont-state-medicaid": { aspectRatio: 1.58 },
"vernon-memorial-healthcare": { aspectRatio: 1.88 },
"veteran-s-association": { aspectRatio: 2.61 },
"veterans-memorial-hospital": { aspectRatio: 1.00 },
"vhc-health": { aspectRatio: 2.78 },
"villagecaremax": { aspectRatio: 1.00 },
"virginia-garcia-memorial-health-center": { aspectRatio: 1.00 },
"virginia-premier-health-plan": { aspectRatio: 1.00 },
"virtua-health": { aspectRatio: 1.73 },
"vitality-health-plan-of-california": { aspectRatio: 1.00 },
"vitruvian-health": { aspectRatio: 3.20 },
"viva-health": { aspectRatio: 1.33 },
"vivent-health": { aspectRatio: 1.51 },
"vna-health-care": { aspectRatio: 1.00 },
"vns-health-health-plans": { aspectRatio: 3.88 },
"vnsny-choice": { aspectRatio: 3.88 },
"vnsny-health": { aspectRatio: 3.88 },
"vnsny": { aspectRatio: 3.88 },
"volunteers-in-medicine-cascades": { aspectRatio: 1.00 },
"vsp": { aspectRatio: 1.91 },
"wabash-general-hospital": { aspectRatio: 2.33 },
"waco-family-medicine": { aspectRatio: 2.25 },
"wakemed-health-and-hospitals": { aspectRatio: 4.41 },
"wallace": { aspectRatio: 2.56 },
"wallowa-memorial-hospital-and-medical-center": { aspectRatio: 5.57 },
"washington-county-hospital-and-clinics": { aspectRatio: 1.00 },
"washington-county-public-health": { aspectRatio: 1.60 },
"washington-health": { aspectRatio: 2.61 },
"washington-regional-medical-system": { aspectRatio: 2.78 },
"washington-state-medicaid": { aspectRatio: 5.57 },
"washoe-tribal-health-center": { aspectRatio: 3.20 },
"watson-clinic": { aspectRatio: 4.41 },
"weill-cornell-medicine": { aspectRatio: 2.78 },
"welbehealth-pace": { aspectRatio: 3.46 },
"welia-health": { aspectRatio: 3.12 },
"well-being-health": { aspectRatio: 1.00 },
"well-sense": { aspectRatio: 1.91 },
"wellcare-by-allwell": { aspectRatio: 2.00 },
"wellcare-by-fidelis-care": { aspectRatio: 1.51 },
"wellcare-health-plans": { aspectRatio: 2.51 },
"wellcare-of-kentucky": { aspectRatio: 1.51 },
"wellcare-of-new-jersey": { aspectRatio: 2.51 },
"wellcare-of-north-carolina": { aspectRatio: 2.00 },
"wellcare-prime-by-absolute-total-care": { aspectRatio: 3.05 },
"wellcare": { aspectRatio: 3.88 },
"wellfirst-health-provided-by-ssm-health-plan-wfh-ssm": { aspectRatio: 1.71 },
"wellfirst-health-wfh": { aspectRatio: 1.00 },
"wellmark-advantage-health-plan": { aspectRatio: 1.83 },
"wellmark-blue-cross-and-blue-shield-of-iowa": { aspectRatio: 4.92 },
"wellmark-blue-cross-and-blue-shield-of-south-dakota": { aspectRatio: 4.92 },
"wellmark-blue-cross-blue-shield-of-iowa": { aspectRatio: 4.92 },
"wellmark-blue-cross-blue-shield-of-south-dakota": { aspectRatio: 4.92 },
"wellmark-blue-cross-blue-shield": { aspectRatio: 4.92 },
"wellpoint": { aspectRatio: 3.12 },
"wellsense-health-plan": { aspectRatio: 1.91 },
"wellspace-health": { aspectRatio: 4.00 },
"wellspan": { aspectRatio: 1.60 },
"wellstar": { aspectRatio: 3.46 },
"west-bend-family-medicine": { aspectRatio: 4.00 },
"west-michigan-cancer-center": { aspectRatio: 3.76 },
"west-tennessee-healthcare": { aspectRatio: 4.41 },
"west-virginia-medicaid": { aspectRatio: 1.91 },
"west-virginia-university": { aspectRatio: 7.11 },
"west-viriginia-medicaid": { aspectRatio: 1.19 },
"west-viriginia-state-medicaid": { aspectRatio: 1.52 },
"wester-health-advantage": { aspectRatio: 1.78 },
"western-health-advantage": { aspectRatio: 1.49 },
"western-michigan-university": { aspectRatio: 1.75 },
"western-montana-clinics": { aspectRatio: 2.25 },
"western-north-carolina-community-health-services": { aspectRatio: 1.60 },
"western-oregon-advanced-health": { aspectRatio: 2.06 },
"western-sky-community-care": { aspectRatio: 2.29 },
"western-university": { aspectRatio: 1.00 },
"western-washington-medical-group": { aspectRatio: 1.71 },
"western-wisconsin-health": { aspectRatio: 1.66 },
"western-wisconsin-urology-oakleaf-medical-network": { aspectRatio: 2.00 },
"whatley-health-services": { aspectRatio: 3.20 },
"whitman-hospital-medical-clinics": { aspectRatio: 1.00 },
"whole-care-pediatrics": { aspectRatio: 2.67 },
"willapa-harbor-hospital": { aspectRatio: 2.72 },
"wilmington-community-clinic": { aspectRatio: 2.84 },
"wilson-health-system": { aspectRatio: 1.00 },
"windom-area-health": { aspectRatio: 1.00 },
"winmind-behavioral-health-and-addiction-medicine": { aspectRatio: 2.03 },
"winner-regional-healthcare": { aspectRatio: 1.00 },
"winneshiek-medical-center": { aspectRatio: 1.33 },
"winters-healthcare": { aspectRatio: 1.00 },
"wiregrass-student-health-clinic": { aspectRatio: 2.91 },
"wisconsin-department-of-health-services": { aspectRatio: 2.17 },
"wisconsin-state-medicaid": { aspectRatio: 5.12 },
"wishing-well-pediatrics": { aspectRatio: 1.00 },
"woman-s": { aspectRatio: 1.00 },
"women-s-college-hospital": { aspectRatio: 2.06 },
"woodlawn-health": { aspectRatio: 4.41 },
"wyandot-memorial-hospital": { aspectRatio: 3.88 },
"wyoming-state-medicaid-non-prod": { aspectRatio: 0.84 },
"wyoming-state-medicaid": { aspectRatio: 0.84 },
"xo-wellness": { aspectRatio: 2.46 },
"yakima-valley-farm-workers-clinic": { aspectRatio: 6.74 },
"yale-new-haven-healthyale-medical-group": { aspectRatio: 3.76 },
"yamhill-community-care-organization": { aspectRatio: 1.97 },
"yazoo-city-medical-clinic": { aspectRatio: 1.00 },
"yelm-family-medicine": { aspectRatio: 1.62 },
"youthcare-healthchoice-illinois": { aspectRatio: 3.66 },
"ziekenhuis-amstelland-directory": { aspectRatio: 1.00 },
"zing-health": { aspectRatio: 4.27 },
};
